/* eslint-disable no-useless-concat */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect, useRef, useCallback} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {createOrder, getPriceList, nonSalesList, getAccesses, getStockAvailability} from '../../../api/modules/order'
import {getAmandemen} from '../../../api/modules/amandemen'
import {create, getFile} from '../../../api/modules/file'
import {
  getProductName,
  getSalesArea,
  getEndUser,
  getSector,
  getIncoterm,
  getProvince3,
  getCity,
  getPlant,
  getPayment,
  getProductType,
  getCustomer,
  getAllPaymentList,
  getCustomerDt,
  getSupplyPoint,
} from '../../../api/modules/getdatalist'
import CustomUseEffect from './CustomUseEffect'
import CurrencyInput from 'react-currency-input-field'
import {getCusGrup, getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import axios from 'axios'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import Select from 'react-select'
import InputGroup from 'react-bootstrap/InputGroup'
import AddRemoveJadwal from './AddRemoveJadwal'
import {MultiSelect} from 'react-multi-select-component'
import {PopoverText} from '../../../components/Popover/Popover'
import {TableBrowseCustomers} from './TableBrowseCustomers'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {orderSelector, setCustomerList, setNumberUrls} from '../../../redux/slices/orderSlices'
import {OrderAmandementTable} from './OrderAmandementTable/OrderAmandementTable'
import {fetchAmandements, headers} from '../../../services/fetcher'
import {amandementSelector} from '../../../redux/slices/amandementSlices'
import {objToParams} from '../../../utils/objToParams'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {authSelector} from 'src/redux/slices/authSlices'
import dateformat from 'src/utils/dateformat'
import getCurrentFormattedDate from 'src/utils/Today'

import {FormCreateCorporation} from './components/FormCreateCorporation'
import {FormCreateRetail} from './components/FormCreateRetail'
import { getAllTransport } from 'src/api/modules/master-data/master'
import { InputFile } from 'src/app/components/InputFile'
import { base64ToBlob } from 'src/app/helpers/file'
import { HakAkses } from 'src/components/mikro/getHakAkses'

const OrderCreate: React.FC = () => {
  const intl = useIntl()
  const {roleId} = useAppSelector(authSelector)
  const {filterAmandement} = useAppSelector(amandementSelector)
  const {customerFilter} = useAppSelector(orderSelector)
  const dispatch = useAppDispatch()

  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [showDetail, setShowDetail] = useState(false)
  const [showDetail2, setShowDetail2] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [arrayEnduser, setEnduserArray] = useState([])
  const [accesses, setAccesses] = useState<any>()
  const [availableSectors, setAvailableSectors] = useState('')

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [retailFlag, setRetailFlag] = useState(false)
  const [tempKontrakID, setTempKontrakID] = useState('')
  const [disable, setDisable] = useState(false)

  //#region
  const [produsen, setProdusen] = useState('')
  const [enduser, setEnduser] = useState('')
  const [sektor, setSektor] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [attachmentIdSektor, setAttachmentIDSector] = useState(0)
  const [incoterm1, setIncoterm1] = useState(0)
  const [commodity, setCommodity] = useState('')
  const [incoterm2, setIncoterm2] = useState(0)
  const [province, setProvince] = useState(0)
  const [country, setCountry] = useState('')
  const [city, setCity] = useState(0)
  const [warehouse, setWarehouse] = useState('')
  const [warehouseDesc, setWarehouseDesc] = useState('')
  const [ptype, setPtype] = useState('')
  const [ptype2, setPtype2] = useState('')
  const [pname, setPname] = useState('')
  const [pnumber, setPnumber] = useState('')
  const [punit, setPunit] = useState('')
  const [pspec, setPspec] = useState('')
  const [subprice, setSubprice] = useState<any>(0)

  const [quantum, setQuantum] = useState<any>(0)
  const [note, setNote] = useState('')
  const [pay1, setPay1] = useState('')
  const [pay2, setPay2] = useState('')
  const [disctribution, setDistribution] = useState('')
  const [shipping, setShipping] = useState(0)
  const [plantcity, setPlantcity] = useState('')
  const [produsenDesc, setProdusenDesc] = useState('')
  const [regarding, setRegarding] = useState('')
  const [enduserDesc, setEnduserDesc] = useState('')
  const [sektorDesc, setSektorDesc] = useState('')
  const [idSektorDesc, setIDSectorDesc] = useState('')
  const [incoterm1Desc, setIncoterm1Desc] = useState(0)
  const [incoterm2Desc, setIncoterm2Desc] = useState(0)
  const [provinceDesc, setProvinceDesc] = useState('')
  const [countryDesc, setCountryDesc] = useState('')
  const [cityDesc, setCityDesc] = useState('')
  const [pay1Desc, setPay1Desc] = useState('')
  const [pay2Desc, setPay2Desc] = useState('')
  const [keterangan, setketerangan] = useState('')
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const [isNoEnduser, setIsNoEnduser] = useState(false)
  const [segment, setSegment] = useState<any>('')
  const [segmentDesc, setSegmentDesc] = useState('')
  const [formulaPrice, setFormulaPrice] = useState(false)
  const [tempRole, setTempRole] = useState<any[]>([])
  const [transType, setTransType] = useState('')
  const [transType2, setTransType2] = useState('')
  const [transportasi, setTransportasi] = useState('')
  const [transOptionType, setTransOptionType] = useState('')
  //#endregion

  // console.log(pay1Desc)

  //#region
  const [salesArea, setSalesArea] = useState<any[]>([])
  const [fullEndUser, setFullEndUser] = useState<any[]>([])
  const [loadingSektor, setLoadingSektor] = useState(false)
  const [fullSector, setFullSector] = useState<any[]>([])
  const [fullIncoterm, setFullIncoterm] = useState<any[]>([])
  const [fullIncoterm2, setFullIncoterm2] = useState<any[]>([])
  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [fullProvinceDest, setFullProvinceDest] = useState<any[]>([])
  const [fullCity, setFullCity] = useState([])
  const [fullPlant, setFullPlant] = useState([])
  const [fullPayment, setFullPayment] = useState([])
  const [fullProductType, setFullProductType] = useState([])
  const [fullProductName, setFullProductName] = useState([])
  const [fullTransport, setFullTransport] = useState([])
  const [tempDetail, setTempDetail] = useState<any>({})
  const [fullSegment, setFullSegment] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [files, setFiles] = useState<any>()
  const [allFile, setAllFiles] = useState<any[]>([])
  const [taking, setTaking] = useState(0)
  const [fixedQuantum, setFixedQuantum] = useState<any>(0)
  const [isUpload, setIsUpload] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [isFileBox, setIsFileBox] = useState(false)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [showApprove, setShowApprove] = useState(false)
  const [fullRole, setFullRole] = useState<any[]>([])
  const [submitOrder, setSubmitOrder] = useState<any[]>([])
  const [submitDesc, setSubmitDesc] = useState<any[]>([])
  const [schedules, setSchedules] = useState<any[]>([])
  const [showJadwal, setShowJadwal] = useState(false)
  const [listNonSales, setListNonSales] = useState<any[]>([])
  const [nonpenjualan, setNonPenjualan] = useState('')
  const [nonPenjualanFlag, setNonPenjualanFlag] = useState('')
  const [SubID, setSubID] = useState(0)

  const isRetail = (sector: any): boolean => (sector == 2 || sector == 4)

  const filteredSector = fullSector.filter((item) => {
    return (regarding == 'PO002' && !isRetail(item.id)) || regarding != 'PO002'
  })

  const [datenow, setDateNow] = useState('')
  let tempkey = 0
  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempTanggal, setTempTanggal] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [daysInMonth, setDaysInMonth] = useState(0)
  const [tempData, setTempData] = useState({
    schedules: [],
    attachments: [],
  })
  const [index2, setIndex2] = useState(0)
  const [listYear, setListYear] = useState<any[]>([])

  const [destinationProvince, setDestinationProvince] = useState<any>(null)
  const [destinationProvinceDesc, setDestinationProvinceDesc] = useState('')
  const [destinationCity, setDestinationCity] = useState<any>(null)
  const [destinationCityDesc, setDestinationCityDesc] = useState('')
  const [fullDestinationCity, setFullDestinationCity] = useState<any[]>([])
  const fullTransportType = [
    {
      label: t('transport-type-darat'),
      value: 'darat'
    },
    {
      label: t('transport-type-laut'),
      value: 'laut'
    },
    {
      label: t('transport-type-lainnya'),
      value: 'lainnya'
    },
  ]

  //#endregion
  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
  }

  const clearStateJadwal = () => {
    setTempTanggal(0)
    setTempMinggu(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
    // setDaysInMonth(0)
    setEditedIndex(null)
  }

  const validasiJadwal = () => {
    if (tempTanggal == 0) return t('Tanggal ke-')
    else if (tempBulan == 0) return t('Bulan ke-')
    else if (tempTahun == 0) return t('Tahun ke-')
    else if (tempTon == 0) return t('Tonnage')
    else return 'nothing'
  }

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const checktaking = () => {
    let temp: any[] = tempData?.schedules
    let tempindex = 0

    if (temp == null) tempindex = 0
    else tempindex = temp.length

    if (tempTahun > year + 1) return 'Tahun tidak boleh melebihi tahun ini'

    if (tempTanggal > getDaysInMonth(tempTahun, tempBulan)) return 'Tanggal melebihi'

    if (tempindex != 0) {
      if (temp[tempindex - 1].year <= tempTahun) {
        if (temp[tempindex - 1].year < tempTahun) {
          if (tempTahun == year) {
            if (tempBulan == month) {
              if (tempTanggal >= day) return 'nothing'
              else return 'Week must be greater than or equal to current week'
            } else if (tempBulan > month) return 'nothing'
            else return 'Month must be greater than or equal to current month'
          } else if (tempTahun > year) return 'nothing'
          else return 'Year must be greater than or equal to current year'
        } else if (temp[tempindex - 1].month <= tempBulan) {
          if (temp[tempindex - 1].month < tempBulan) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else if (temp[tempindex - 1].date < tempTanggal) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else return 'Week must be greater than previous week'
        } else return 'Month must be greater than previous month'
      } else return 'Year must be greater than previous year'
    } else {
      if (tempTahun == year) {
        if (tempBulan == month) {
          if (tempTanggal >= day || day > 28) return 'nothing'
          else return 'Week must be greater than or equal to current week'
        } else if (tempBulan > month) return 'nothing'
        else return 'Month must be greater than or equal to current month'
      } else if (tempTahun > year) return 'nothing'
      else return 'Year must be greater than or equal to current year'
    }
  }

  const [editedIndex, setEditedIndex] = useState<any>()

  const rubahSchedule = (index: any, tonnage: any, tonlama: any) => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    const tempOrder: any[] = [...submitOrder]
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        if (tempTon != 0) {
          if (tempOrder[index2]?.request_quantum >= tempoquantum - tonlama + tempTon) {
            let temp: any[] = tempData?.schedules
            temp[index].tonnage = tonnage
            tempOrder[index2].schedules = temp
            setEditedIndex(null)
            setAllJadwal(temp)
            setSubmitOrder(tempOrder)
            swal({
              title: `${t('jadwalBerhasilDiEdit')}`,
              icon: 'success',
            })
          } else {
            swal({
              title: t('Melebihi Tonase!'),
              icon: 'error',
            })
          }
        } else {
          swal({
            title: t('isi') + t('Tonnage'),
            icon: 'error',
          })
        }
      } else return setEditedIndex(null)
    })
  }

  const hapusSchedule = (index: any) => {
    const tempOrder: any[] = [...submitOrder]
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        let temp: any[] = tempData?.schedules
        temp.splice(index, 1)
        tempOrder[index2].schedules = temp
        setEditedIndex(null)
        const temptaking = taking - 1
        setTaking(temptaking)
        setAllJadwal(temp)
        setSubmitOrder(tempOrder)
        swal({
          closeOnClickOutside: false,
          title: t('deleted successfully'),
          icon: 'success',
        })
      } else return setEditedIndex(null)
    })
  }

  const sendJadwal = () => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })

    const checkMandatory = validasiJadwal()
    const CheckTaking = checktaking()
    const tempOrder: any[] = [...submitOrder]
    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (tempOrder[index2]?.request_quantum >= tempoquantum + tempTon) {
          let temp: any[] = tempData?.schedules
          let sort = tempData?.schedules?.length
          const tempobject = {
            sort: sort + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }

          if (temp == null) {
            const temp2 = []
            temp2.push(tempobject)
            temp = temp2
          } else {
            temp.push(tempobject)
          }
          const temptaking = taking + 1
          setTaking(temptaking)
          tempOrder[index2].schedules = temp
          setAllJadwal(temp)
          setSubmitOrder(tempOrder)
          clearInputJadwal()
          clearStateJadwal()
          // setShowJadwal(false)
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  const handleJadwal = (item: any) => {
    setTempData(item)
    setAllJadwal(item?.schedules)

    if (item?.schedules?.length == undefined) {
      setTaking(0)
    } else {
      setTaking(item?.schedules?.length)
    }

    setShowJadwal(true)
  }

  const [test, setTest] = useState<any>({
    sales_org_code: '',
    end_user: '',
    sector_id: 0,
    incoterm1_id: '',
    incoterm2_id: '',
    province_id: '',
    country: '',
    country_desc: '',
    city_id: '',
    city_plant: '',
    plant: '',
    plant_desc: '',
    material_number: '',
    product_type: '',
    product_name: '',
    product_spec: '',
    request_price: '',
    request_quantum: '',
    payment_type_1: '',
    payment_type_2: '',
    include_ppn: false,
    no_enduser: false,
    is_formulated_price: false,
    notes: '',
    payment_note: '',
    shipping_tolerance: '',
  })

  const [tempID, setTempID] = useState(0)

  const handleClose1 = () => setShow1(false)
  const handleShow1 = async () => {
    ambilAttachment()
    setShow1(true)
  }
  const handleClose2 = () => setShow2(false)
  const handleShow2 = async () => {
    let cred: any = ''
    if (!isAdmin) cred = localStorage.getItem('cust-code')
    else cred = customerID
    // setLoading(true);
    try {
      await getSalesArea(cred).then((res) => {
        setSalesArea(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_org + '~#~' + item.distribution_channel + '~#~' + item.produsen?.name,
              label: item.produsen?.name,
            }
          })
        )
        setLoading(false)
      })
      // if (localStorage.getItem('cust-group') != undefined) {
      //   if (localStorage.getItem('cust-group') == 'AR03') setRetailFlag(true)
      // }
    } catch {
      setLoading(false)
    }
    setShow2(true)
  }

  const reloadData = async () => {
    let cred: any = ''
    if (!isAdmin) cred = localStorage.getItem('cust-code')
    else cred = customerID

    try {
      getSector(disctribution, {
        credentials: localStorage.getItem('credential')
      }).then((res) => {
        const temp: any[] = res.data.data
        setFullSector(temp)
        // if (roleUser == 'salesAdmin') {
        //   let index = temp?.findIndex((item: any) => item.id === 2)
        //   if (index != -1) temp.splice(index, 1)
        //   setFullSector(temp)
        // } else setFullSector(temp)
      })
    } catch {}

    try {
      getEndUser('').then((res) => {
        setFullEndUser(res.data.data)
      })
    } catch {}

    getCusGrup().then((res) => {
      setFullSegment(res.data.data)
    })

    try {
      setLoadingSektor(true)
      await getSector(disctribution).then((res) => {
        const temp: any[] = res.data.data

        if (isAdmin) {
          let _availableSectors = availableSectors?.split("|")
          setFullSector(temp.filter((item: any) => _availableSectors?.includes(item.id+'')))
        } else {
          let _availableSectors = localStorage.getItem('sector_ids')?.split("|")
          setFullSector(temp.filter((item: any) => _availableSectors?.includes(item.id+'')))
        }
        setLoadingSektor(false)
      })
    } catch {
      setLoadingSektor(false)
    }

    try {
      await getIncoterm().then((res) => {
        let temparray: any[] = [{value: 0 + '~#~', label: t('Pilih-incoterm')}]
        res.data.data.forEach((item: any) => {
          temparray.push({value: item.id + '~#~' + item.code, label: item.code})
        })
        setFullIncoterm(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.code,
              label: item.code,
            }
          })
        )
        // console.log(temparray)
        setFullIncoterm2(temparray)
      })
    } catch {}

    try {
      getProductType('').then((res) => {
        setFullProductType(res.data.data)
      })
    } catch {}

    setLoading(false)
  }

  CustomUseEffect(() => {
    const getTransport = async () => {
      try{
        setFullTransport([])
        const res = await getAllTransport()
        setFullTransport(res.data.data)
      }catch(e){}
    }

    if (isRetail(idSektor)) {
      setRetailFlag(true)
      getTransport()
      setCommodity('')
    } else setRetailFlag(false)
  }, [idSektor])

  const getprov = async () => {
    let options: Record<string, any> = {}

    if(isRetail(idSektor)) {
      if (isAdmin) options.customer_code = customerID
      else options.customer_code = localStorage.getItem("cust-code")

      options.sales_org_code = produsen
    }

    await getProvince3(options).then((res) => {
      setFullProvince(
        res.data.data.map((item: any) => {
          return {
            value: item.sales_office + '~#~' + item.controlling_area,
            label: item.controlling_area,
          }
        })
      )
    })
    if (isRetail(idSektor)) {
      await getProvince3().then((res) => {
        setFullProvinceDest(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + '~#~' + item.controlling_area,
              label: item.controlling_area,
            }
          })
        )
      })
    }
  }

  CustomUseEffect(() => {
    const getfullcity = async () => {
      await getCity(province).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
      // fieldClearer(5)
      fieldClearer('province')
    }
    if (province != undefined) getfullcity()
  }, [province])

  CustomUseEffect(() => {
    const getfullcity = async () => {
      setDestinationCity(null)
      setDestinationCityDesc('')
      await getCity(destinationProvince).then((res) => {
        setFullDestinationCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
      // fieldClearer(5)
      // fieldClearer('province')
    }
    if (destinationProvince != undefined) getfullcity()
  }, [destinationProvince])

  const [showUpload, setShowUpload] = useState(false)

  const tampilUpload = async (id: any, paramm: any) => {
    await getFile(paramm, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setShowUpload(true)
    })
  }

  const cityData = async (value: any) => {
    const tempName = value.split('~#~')
    setProvince(parseInt(tempName[0]))
    setProvinceDesc(tempName[1])
  }
  const cityDestinationData = async (value: any) => {
    const tempName = value.split('~#~')
    setDestinationProvince(parseInt(tempName[0]))
    setDestinationProvinceDesc(tempName[1])
  }

  const plantData = async () => {
    let temp: string[] = []
    if (sektor != '') {
      temp = sektor.split('~#~')
    }
    // setIDSector(parseInt(temp[0]))
    // console.log("prod ", produsen, ", sektor ", sektor, ", city ", city)
    try {
      setFullPlant([])
      if (produsen != '' && sektor != '') {
        if(isRetail(idSektor)){
          await getSupplyPoint({
            sales_org_code: produsen ?? '',
            plant_code: '',
            province_id: province ?? '',
            city_id: city ?? '',
            scnd_sales_group_id: '',
            status: 'y',
            material_number: '',
          }).then((res) => {
            setFullPlant(
              res.data.data.map((item: any) => {
                return {
                  value: item.plant_code + '~#~' + item.plant_name + '~#~' + item.plant_city_name,
                  label: item.plant_code + '-' + item.plant_name,
                }
              })
            )
          })
        }else{
          await getPlant(produsen, disctribution, province, {
            city_code: city
          }).then((res) => {
            setFullPlant(
              res.data.data.map((item: any) => {
                return {
                  value: item.plant + '~#~' + item.plant_name + '~#~' + item.city_name,
                  label: item.plant + '-' + item.plant_name,
                }
              })
            )
          })
        }
      }
    } catch {}
  }

  const productTypeChange = (value: any) => {
    const tempType = value.split('~#~')
    // if(tempType[1] == 'P13'){
    //   const ckbox = document.getElementById('noenduser1') as HTMLInputElement
    //   if (ckbox != null) ckbox.checked = true
    //   console.log(ckbox)
    //   setIsNoEnduser(true)
    // }
    setPtype2(tempType[0])
    setPtype(tempType[1])
    // fieldClearer(2)
    fieldClearer('tipe')
  }

  const productNameChange = (value: any) => {
    const tempName = value.split('~#~')
    const productName = tempName[1]
    if (tempName[0] != '0' || regarding == 'PO002') setPname(productName)

    setPnumber(tempName[0])
    if(tempName[2]) setPunit(tempName[2])
    // console.log(tempName)
  }

  const plantChange = (value: any) => {
    const tempName = value.split('~#~')
    setWarehouse(tempName[0])
    setWarehouseDesc(tempName[1])
    setPlantcity(tempName[2])
    fieldClearer('warehouse')
  }

  const ambilAttachment = async () => {
    await getFile(
      'header',
      parseInt(sessionStorage.getItem('po')!),
      localStorage.getItem('credential')!
    ).then((res) => {
      setAllFiles(res.data.data)
    })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const [language, setLanguage] = useState<any>()

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const [loadingAddProduct, setLoadingAddProduct] = useState(false)

  const checkStock = async () => {
      try{
        setLoadingAddProduct(true)
        const resp = await getStockAvailability({
          credentials: localStorage.getItem('credential'),
          material_number: parseInt(pnumber+''),
          unit: punit,
          plant: warehouse,
          quantum: parseFloat(quantum)
        })

        setLoadingAddProduct(false)
        if(resp.data.data) return true

        swal({
          title: t('Failed, stock not available!'),
          icon: 'error',
        })
        return false
      }catch(e){
        setLoadingAddProduct(false)
        swal({
          title: t('Failed, stock not available!'),
          icon: 'error',
        })
        return false
      }
  }

  const getTransportInfo = () => {
    return transOptionType == "lainnya" ? transportasi : transOptionType;
  }

  const insertAddOrder = async () => {
    const mandatoryCheck = checkMandatory()

    if (mandatoryCheck == 'nothing') {

      if(isRetail(idSektor)) {
        const isAvailable = await checkStock()
        if(!isAvailable) return
      }

      let enduser1: any = []
      let enduser2: any = []
      if (!isNoEnduser && idSektor == 1) {
        arrayEnduser.forEach((data: any) => {
          enduser1.push(data.value)
          enduser2.push(data.label)
        })
      } else {
        enduser1 = enduserDesc
        enduser2 = enduserDesc
        // console.log(enduser1, enduser2)
      }
      if (showPurchaseForm) {
        const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
        let ppn = false
        if (ckbox != null) {
          if (ckbox.checked) ppn = true
          else ppn = false
        }

        let temptol = shipping
        if (isNaN(temptol)) temptol = 0
        else temptol = shipping
        const tempOrder = submitOrder
        const tempOrder2 = submitDesc
        const temp = {
          sales_org_code: produsen,
          end_user: isRetail(idSektor) ? enduser : enduser1.toString(),
          sector_id: idSektor,
          incoterm1_id: incoterm1,
          incoterm2_id: isRetail(idSektor) ? plantcity : incoterm2,
          province_id: province,
          segment_code: segment,
          segment_name: segmentDesc,
          country: country,
          country_desc: countryDesc,
          city_id: city,
          plant: warehouse,
          plant_desc: warehouseDesc,
          city_plant: plantcity,
          material_number: pnumber,
          unit: punit,
          product_type: ptype,
          product_type_desc: ptype2,
          product_name: pname,
          product_spec: pspec,
          request_price: formulaPrice === true ? 0 : parseFloat(subprice),
          request_quantum: parseFloat(quantum),
          payment_type_1: pay1,
          payment_type_1_desc: pay1Desc,
          payment_type_2: pay2,
          payment_type_2_desc: pay2Desc,
          notes: note,
          payment_note: keterangan,
          include_ppn: ppn,
          is_formulated_price: formulaPrice,
          shipping_tolerance: temptol,
          attachments: [],
          end_user_multiple: idSektor != 1 ? false : !isNoEnduser,
          province_dest_id: province,
          city_dest_id: city,
          moda_angkut_type: isRetail(idSektor) ? transType : undefined,
          moda_angkut_type_en: isRetail(idSektor) ? transType2 : undefined,
          moda_angkut_name: isRetail(idSektor) ? getTransportInfo() : undefined,
          commodity: commodity
        }
        const temp2 = {
          sales_org_code: produsenDesc,
          end_user: isRetail(idSektor) ? enduser : enduser2.toString(),
          sector_id: sektorDesc,
          incoterm1_id: incoterm1Desc,
          incoterm2_id: isRetail(idSektor) ? plantcity : incoterm2Desc,
          province_id: provinceDesc,
          country: countryDesc,
          country_desc: countryDesc,
          city_id: cityDesc,
          plant: warehouse,
          plant_desc: warehouseDesc,
          city_plant: plantcity,
          material_number: pnumber,
          unit: punit,
          product_type: ptype2,
          product_name: pname,
          product_spec: pspec,
          request_price: formulaPrice === true ? 0 : parseFloat(subprice),
          request_quantum: parseFloat(quantum),
          payment_type_1: pay1Desc,
          payment_type_2: pay2Desc,
          include_ppn: ppn,
          is_formulated_price: formulaPrice,
          segment_name: segmentDesc,
          payment_note: keterangan,
          shipping_tolerance: temptol,
          notes: note,
          no_enduser: idSektor != 1 ? true : isNoEnduser,
          province_dest_id: provinceDesc,
          city_dest_id: cityDesc,
          moda_angkut_type: isRetail(idSektor) ? transType : undefined,
          moda_angkut_type_en: isRetail(idSektor) ? transType2 : undefined,
          moda_angkut_name: isRetail(idSektor) ? getTransportInfo() : undefined,
          commodity: commodity
        }
        tempOrder.push(temp)
        setSubmitOrder(tempOrder)

        tempOrder2.push(temp2)
        setSubmitDesc(tempOrder2)
        setSubprice(0)
        setShow2(false)
      } else if (nonPenjualanFlag == 'form1') {
        // let ppn = true
        // if (PPN?.id != null) {
        //   if (PPN?.id == 'exclude') ppn = false
        //   else ppn = true
        // }
        const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
        let ppn = false
        if (ckbox != null) {
          if (ckbox.checked) ppn = true
          else ppn = false
        }
        const tempOrder = submitOrder
        const tempOrder2 = submitDesc
        const temp = {
          sales_org_code: produsen,
          sector_id: idSektor,
          end_user: enduser1.toString(),
          incoterm1_id: incoterm1,
          product_type: ptype,
          product_type_desc: ptype2,
          material_number: pnumber,
          unit: punit,
          product_name: pname,
          province_id: province,
          city_id: city,
          product_spec: pspec,
          request_price: parseFloat(subprice),
          request_quantum: parseFloat(quantum),
          notes: note,
          include_ppn: ppn,
          attachments: [],
          end_user_multiple: idSektor != 1 ? false : !isNoEnduser,
          moda_angkut_type: isRetail(idSektor) ? transType : undefined,
          moda_angkut_type_en: isRetail(idSektor) ? transType2 : undefined,
          moda_angkut_name: isRetail(idSektor) ? getTransportInfo() : undefined,
        }
        const temp2 = {
          sales_org_code: produsenDesc,
          sector_id: sektorDesc,
          incoterm1_id: incoterm1Desc,
          province_id: provinceDesc,
          city_id: cityDesc,
          material_number: pnumber,
          unit: punit,
          product_type: ptype2,
          product_name: pname,
          request_price: parseFloat(subprice),
          request_quantum: parseFloat(quantum),
          include_ppn: ppn,
          notes: note,
          end_user: enduser2.toString(),
          no_enduser: idSektor != 1 ? true : isNoEnduser,
          moda_angkut_type: isRetail(idSektor) ? transType : undefined,
          moda_angkut_type_en: isRetail(idSektor) ? transType2 : undefined,
          moda_angkut_name: isRetail(idSektor) ? getTransportInfo() : undefined,
        }
        tempOrder.push(temp)
        setSubmitOrder(tempOrder)

        tempOrder2.push(temp2)
        setSubmitDesc(tempOrder2)
        setSubprice(0)
        setShow2(false)
      } else {
        const tempOrder = submitOrder
        const tempOrder2 = submitDesc
        const temp = {
          sales_org_code: produsen,
          sector_id: idSektor,
          product_type: ptype,
          product_type_desc: ptype2,
          material_number: pnumber,
          unit: punit,
          product_name: pname,
          notes: note,
          attachments: [],
          end_user: enduser1.toString(),
          end_user_multiple: idSektor != 1 ? false : !isNoEnduser,
        }
        const temp2 = {
          sales_org_code: produsenDesc,
          sector_id: sektorDesc,
          material_number: pnumber,
          unit: punit,
          product_type: ptype2,
          product_name: pname,
          notes: note,
          end_user: enduser1.toString(),
          no_enduser: idSektor != 1 ? true : isNoEnduser,
        }
        tempOrder.push(temp)
        setSubmitOrder(tempOrder)

        tempOrder2.push(temp2)
        setSubmitDesc(tempOrder2)
        setSubprice(0)
        setShow2(false)
      }
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
    if (submitOrder.length > 0) setAttachmentIDSector(submitOrder[0].sector_id)
  }

  const [PPN, setPPN] = useState<any>('')

  const editOrder = async (index: any) => {
    const mandatoryCheck = checkMandatory()
    
    if (mandatoryCheck == 'nothing') {
      
      if(isRetail(idSektor)) {
        const isAvailable = await checkStock()
        if(!isAvailable) return
      }

      let enduser1: any = []
      let enduser2: any = []
      if (!isNoEnduser && idSektor == 1) {
        arrayEnduser.forEach((data: any) => {
          enduser1.push(data.value)
          enduser2.push(data.label)
        })
      } else {
        enduser1 = enduserDesc
        enduser2 = enduserDesc
      }
      if (showPurchaseForm) {
        const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
        let ppn = false
        if (ckbox != null) {
          if (ckbox.checked) ppn = true
          else ppn = false
        }
        const ckboxFormula = document.getElementById('formula_Price') as HTMLInputElement
        let formula = false
        if (ckboxFormula != null) {
          if (ckboxFormula.checked) formula = true
          else formula = false
        }
        let temptol = shipping
        if (isNaN(temptol)) temptol = 0
        else temptol = shipping
        const tempOrder: any[] = [...submitOrder]
        tempOrder[index].commodity = commodity
        tempOrder[index].sales_org_code = produsen
        tempOrder[index].end_user = enduser1.toString()
        tempOrder[index].sector_id = idSektor
        tempOrder[index].incoterm1_id = incoterm1
        tempOrder[index].incoterm2_id = incoterm2
        tempOrder[index].province_id = province
        tempOrder[index].segment_code = segment
        tempOrder[index].segment_name = segmentDesc
        tempOrder[index].country = country
        tempOrder[index].country_desc = countryDesc
        tempOrder[index].city_id = city
        tempOrder[index].plant = warehouse
        tempOrder[index].plant_desc = warehouseDesc
        tempOrder[index].city_plant = plantcity
        tempOrder[index].material_number = pnumber
        tempOrder[index].unit = punit
        tempOrder[index].product_type = ptype
        tempOrder[index].product_type_desc = ptype2
        tempOrder[index].product_name = pname
        tempOrder[index].product_spec = pspec
        tempOrder[index].request_price = formula ? 0 : parseFloat(subprice)
        tempOrder[index].request_quantum = parseFloat(quantum)
        tempOrder[index].payment_type_1 = pay1
        tempOrder[index].payment_type_2 = pay2
        tempOrder[index].notes = note
        tempOrder[index].payment_type_1_desc = pay1Desc
        tempOrder[index].payment_type_2_desc = pay2Desc
        tempOrder[index].include_ppn = ppn
        tempOrder[index].is_formulated_price = formula
        tempOrder[index].payment_note = keterangan
        tempOrder[index].shipping_tolerance = temptol
        tempOrder[index].attachments = tempFiles
        tempOrder[index].province_dest_id = province
        tempOrder[index].city_dest_id = city
        if (idSektor == 1) tempOrder[index].end_user_multiple = !isNoEnduser
        else tempOrder[index].end_user_multiple = false
        if (isRetail(idSektor)){
          tempOrder[index].moda_angkut_type = transType
          tempOrder[index].moda_angkut_type_en = transType2
          tempOrder[index].moda_angkut_name = transportasi
        }

        const tempOrder2: any[] = [...submitDesc]
        tempOrder2[index].commodity = commodity
        tempOrder2[index].sales_org_code = produsenDesc
        tempOrder2[index].end_user = enduser2.toString()
        tempOrder2[index].sector_id = sektorDesc
        tempOrder2[index].incoterm1_id = incoterm1Desc
        tempOrder2[index].incoterm2_id = incoterm2Desc
        tempOrder2[index].province_id = provinceDesc
        tempOrder2[index].country = countryDesc
        tempOrder2[index].segment_name = segmentDesc
        tempOrder2[index].country_desc = countryDesc
        tempOrder2[index].city_id = cityDesc
        tempOrder2[index].plant = warehouse
        tempOrder2[index].plant_desc = warehouseDesc
        tempOrder2[index].city_plant = plantcity
        tempOrder2[index].material_number = pnumber
        tempOrder2[index].unit = punit
        tempOrder2[index].product_type = ptype2
        tempOrder2[index].product_name = pname
        tempOrder2[index].product_spec = pspec
        tempOrder2[index].request_price = formula ? 0 : parseFloat(subprice)
        tempOrder2[index].request_quantum = parseFloat(quantum)
        tempOrder2[index].payment_type_1 = pay1Desc
        tempOrder2[index].payment_type_2 = pay2Desc
        tempOrder2[index].include_ppn = ppn
        tempOrder2[index].is_formulated_price = formula
        tempOrder2[index].payment_note = keterangan
        tempOrder2[index].shipping_tolerance = temptol
        tempOrder2[index].notes = note
        tempOrder2[index].province_dest_id = provinceDesc
        tempOrder2[index].city_dest_id = cityDesc
        // tempOrder2[index].no_enduser = isNoEnduser
        if (idSektor == 1) tempOrder2[index].no_enduser = isNoEnduser
        else tempOrder2[index].no_enduser = false

        if (isRetail(idSektor)){
          tempOrder2[index].moda_angkut_type = transType
          tempOrder2[index].moda_angkut_type_en = transType2
          tempOrder2[index].moda_angkut_name = transportasi
        }

        setSubmitOrder(tempOrder)
        setSubmitDesc(tempOrder2)
        setSubprice(0)

        swal({
          title: `${t('dataBerhasilDiubah')}`,
          icon: 'success',
        })
        setShowEdit(false)
      } else if (nonPenjualanFlag == 'form1') {
        const tempOrder: any[] = [...submitOrder]

        // let ppn = tempOrder[index].include_ppn
        // if (PPN?.id != null || PPN != '')
        //   if (PPN?.id == 'include' || PPN == 'include') ppn = true
        //   else ppn = false

        const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
        let ppn = false
        if (ckbox != null) {
          if (ckbox.checked) ppn = true
          else ppn = false
        }

        tempOrder[index].sales_org_code = produsen
        tempOrder[index].end_user = enduser1.toString()
        tempOrder[index].sector_id = idSektor
        tempOrder[index].incoterm1_id = incoterm1
        tempOrder[index].province_id = province
        tempOrder[index].city_id = city
        tempOrder[index].material_number = pnumber
        tempOrder[index].unit = punit
        tempOrder[index].product_type = ptype
        tempOrder[index].product_type_desc = ptype2
        tempOrder[index].product_name = pname
        tempOrder[index].product_spec = ''
        tempOrder[index].request_price = parseFloat(subprice)
        tempOrder[index].request_quantum = parseFloat(quantum)
        tempOrder[index].notes = note
        tempOrder[index].include_ppn = ppn
        tempOrder[index].attachments = tempFiles
        if (idSektor == 1) tempOrder[index].end_user_multiple = !isNoEnduser
        else tempOrder[index].end_user_multiple = false

        const tempOrder2: any[] = [...submitDesc]
        tempOrder2[index].sales_org_code = produsenDesc
        tempOrder2[index].end_user = enduser2.toString()
        tempOrder2[index].sector_id = sektorDesc
        tempOrder2[index].incoterm1_id = incoterm1Desc
        tempOrder2[index].province_id = provinceDesc
        tempOrder2[index].city_id = cityDesc
        tempOrder2[index].material_number = pnumber
        tempOrder2[index].unit = punit
        tempOrder2[index].product_type = ptype2
        tempOrder2[index].product_name = pname
        tempOrder2[index].product_spec = pspec
        tempOrder2[index].request_price = parseFloat(subprice)
        tempOrder2[index].request_quantum = parseFloat(quantum)
        tempOrder2[index].include_ppn = ppn
        tempOrder2[index].notes = note
        if (idSektor == 1) tempOrder2[index].no_enduser = isNoEnduser
        else tempOrder2[index].no_enduser = false

        // console.log(temp2)
        // tempOrder.push(temp)
        setSubmitOrder(tempOrder)
        // console.log(JSON.stringify(submitOrder) + ' end')

        // tempOrder2.push(temp2)
        setSubmitDesc(tempOrder2)
        // console.log(JSON.stringify(submitDesc) + ' end')
        setSubprice(0)

        swal({
          title: `${t('dataBerhasilDiubah')}`,
          icon: 'success',
        })
        setShowEdit(false)
      } else {
        const tempOrder: any[] = [...submitOrder]
        tempOrder[index].sales_org_code = produsen
        tempOrder[index].sector_id = idSektor
        tempOrder[index].material_number = pnumber
        tempOrder[index].unit = punit
        tempOrder[index].product_type = ptype
        tempOrder[index].product_type_desc = ptype2
        tempOrder[index].product_name = pname
        tempOrder[index].notes = note
        tempOrder[index].attachments = tempFiles
        tempOrder[index].end_user = enduser1.toString()
        tempOrder[index].end_user_multiple = !isNoEnduser

        const tempOrder2: any[] = [...submitDesc]
        tempOrder2[index].sales_org_code = produsenDesc
        tempOrder2[index].sector_id = sektorDesc
        tempOrder2[index].material_number = pnumber
        tempOrder2[index].unit = punit
        tempOrder2[index].product_type = ptype2
        tempOrder2[index].product_name = pname
        tempOrder2[index].notes = note
        tempOrder2[index].end_user = enduser2.toString()
        tempOrder2[index].no_enduser = isNoEnduser
        setSubmitOrder(tempOrder)
        setSubmitDesc(tempOrder2)
        setSubprice(0)

        swal({
          title: `${t('dataBerhasilDiubah')}`,
          icon: 'success',
        })
        setShowEdit(false)
      }
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
    if (submitOrder.length > 0) setAttachmentIDSector(submitOrder[0].sector_id)
  }

  const setState = (item: any, index: any) => {
    clearState()
    setProdusen(item.sales_org_code)
    setEnduser(item.end_user)
    setIDSector(item.sector_id)
    setIncoterm1(item.incoterm1_id)
    setIncoterm2(item.incoterm2_id)
    setProvince(item.province_id)
    setCountry(item.country)
    setCountryDesc(item.country_desc)
    setCity(item.city_id)
    setWarehouse(item.plant)
    if (item.include_ppn == true) setPPN('include')
    else setPPN('exclude')
    setWarehouseDesc(item.plant_desc)
    setPnumber(item.material_number)
    setPunit(item.unit)
    setPtype(item.product_type)
    setPname(item.product_name)
    setPspec(item.product_spec)
    setSubprice(item.request_price || 0)
    setQuantum(item.request_quantum)
    setPay1(item.payment_type_1)
    setPay2(item.payment_type_2)
    setTempFiles(item.attachments)
    setketerangan(item.payment_note)
    setShipping(item.shipping_tolerance)
    setSegment(item.segment_code)
    setSegmentDesc(item.segment_name)
    setCommodity(item.commodity)

    setDestinationProvince(item.province_dest_id)
    setDestinationCity(item.city_dest_id)

    if (submitDesc[index].no_enduser) {
      setEnduserArray([])
      setEnduser(item.end_user)
      setEnduserDesc(item.end_user)
    } else {
      const tempenduser = submitDesc[index].end_user.split(',')
      // console.log(submitDesc[index].end_user)
      const temparray: any = []
      tempenduser.forEach((items: any, _index: any) => {
        let temp = {label: items, value: items}
        temparray.push(temp)
      })
      setEnduserArray(temparray)
    }
    // setEnduserDesc(submitDesc[index].end_user)
    setProdusenDesc(submitDesc[index].sales_org_code)
    setSektorDesc(submitDesc[index].sector_id)
    setIncoterm1Desc(submitDesc[index].incoterm1_id)
    setIncoterm2Desc(submitDesc[index].incoterm2_id)
    setCountryDesc(submitDesc[index].country)
    setCityDesc(submitDesc[index].city_id)
    setProvinceDesc(submitDesc[index].province_id)
    setWarehouseDesc(submitDesc[index].plant_desc)
    setPtype2(submitDesc[index].product_type)
    setPay1Desc(submitDesc[index].payment_type_1)
    setPay2Desc(submitDesc[index].payment_type_2)
    setFormulaPrice(submitDesc[index].is_formulated_price)
    setIsNoEnduser(submitDesc[index].no_enduser)
    setDestinationProvinceDesc(submitDesc[index].province_dest_id)
    setDestinationCityDesc(submitDesc[index].city_dest_id)
    setEnduser(submitDesc[index].end_user)
    setEnduserDesc(submitDesc[index].end_user)

    setTransType(submitDesc[index].moda_angkut_type)
    setTransType2(submitDesc[index].moda_angkut_type_en)
    if(submitDesc[index].moda_angkut_name){
      if(['laut', 'darat'].includes(submitDesc[index].moda_angkut_name as string)){
        setTransOptionType(submitDesc[index].moda_angkut_name)
        setTransportasi("")
      }else{
        setTransOptionType("lainnya")
        setTransportasi(submitDesc[index].moda_angkut_name)
      }
    }
    // if (submitDesc[index].no_enduser == false) setDisableCKBOX(true)
    // else setDisableCKBOX(false)
    setShowEdit(true)
    // const munculEdit = setTimeout(() => {
    // }, 2000)
    // return () => clearTimeout(munculEdit)
    return () => {}
    // console.log(cityDesc)
  }

  const clearState = () => {
    setDisableCKBOX(false)
    setEnduser('')
    setEnduserDesc('')
    setIDSector(0)
    setIncoterm1(0)
    setIncoterm2(0)
    setProvince(0)
    setCountry('')
    setCountryDesc('')
    setCity(0)
    setWarehouse('')
    setWarehouseDesc('')
    setPtype('')
    setPname('')
    setPnumber('')
    setPspec('')
    setSegment('')
    setSegmentDesc('')
    setSubprice(0)
    setQuantum(0)
    setPay1('')
    setPay2('')
    setketerangan('')
    setPPN('')
    setCommodity('')
    setFormulaPrice(false)
    setEnduserArray([])
    if (localStorage.getItem('cust-group') == 'AR06') {
      setIDSector(3)
      setSektorDesc('Export')
    }
  }

  const checkMandatory = () => {
    if (showPurchaseForm) {
      if (produsen == '') return t('isi') + t('Sales Org')
      else if (
        (idSektor == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
        (!isRetail(idSektor) && isNoEnduser == true && enduser == '') ||
        (idSektor == 3 && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (idSektor == 0) return t('isi') + t('Sector')
      else if (incoterm1 == 0) return t('isi') + 'Incoterm 1'
      else if (province == 0) return t('isi') + t('Province')
      else if (city == 0) return t('isi') + t('City')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (pnumber == '') return t('isi') + t('Product Name')
      // else if ((subprice == 0 || subprice == '') && formulaPrice == false)
      else if (
        roleUser != 'null' && (
        (!isRetail(idSektor) && (subprice == 0 || subprice == '') && formulaPrice == false) ||
        (isRetail(idSektor) && (subprice === '' || subprice === null))
        )
      ) {
        return t('isi') + t('Submission Price')
      } else if (quantum == 0 || quantum == '') return t('isi') + t('Quantum')
      else if (pay1 == '') return t('isi') + t('Payment 1')
      else if (shipping < 0) return t('shipping tolerance tidak boleh minus')
      else if (idSektor == 1 && segment == '') return t('isi') + 'segment'
      // else if (isRetail(idSektor) && !pspec) return t('isi') + t('sub-order-spek')
      // else if (Number.isNaN(shipping)) return t('shipping harus angka')
      else if (shipping >= 100) return t('Shipping tolerance melebihi 100%')
      // else if ((shipping == 0 || Number.isNaN(shipping)) && !isRetail(idSektor))
      //   return t('isi') + t('Shipping Tolerance')
      // else if (ptype == 'P13' && (pay1Desc == 'Cash Payment' || pay2Desc == 'Cash Payment'))
      //   return t('Pembayaran Tidak Boleh Cash')
      else if (isRetail(idSektor) && !transType) return t('isi') + t('so-jenisAngkut')
      else if (isRetail(idSektor) && !getTransportInfo()) return t('isi') + t('so-namaAngkut')
      else return 'nothing'
    } else if (nonPenjualanFlag == 'form1') {
      if (produsen == '') return t('isi') + t('Sales Org')
      // else if (enduser == '' || enduser == '0') return t('isi') + t('End Customer')
      else if (
        (idSektor == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
        (isNoEnduser == true && enduser == '') ||
        (idSektor != 1 && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (idSektor == 0) return t('isi') + t('Sector')
      else if (incoterm1 == 0) return t('isi') + 'Incoterm 1'
      else if (province == 0 && idSektor != 3) return t('isi') + t('Province')
      else if (city == 0 && idSektor != 3) return t('isi') + t('City')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (pnumber == '') return t('isi') + t('Product Name')
      // else if (subprice == 0 || subprice == '') return t('isi') + t('Submission Price')
      else if (quantum == 0 || quantum == '') return t('isi') + t('Quantum')
      else return 'nothing'
    } else {
      if (produsen == '') return t('isi') + t('Sales Org')
      else if (idSektor == 0) return t('isi') + t('Sector')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (
        (idSektor == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
        (isNoEnduser == true && enduser == '') ||
        (idSektor != 1 && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (pnumber == '') return t('isi') + t('Product Name')
      else return 'nothing'
    }
  }

  const postOrder = async () => {
    setDisable(true)
    setBtnLoading(true)
    const cred = JSON.parse(localStorage.getItem('credential-decoded')!)
    const headerArray: any[] = []

    fileHeader?.forEach((data: any, _index: any) => {
      headerArray.push(data)
      if (headerArray?.length > -1) {
        const temp = data?.file_r.split(',')
        if (temp[1] != undefined) headerArray[_index].file_r = temp[1]
      }
    })

    const orderitemArray: any[] = []
    submitOrder.forEach((data: any, _index: any) => {
      let temparr: any = data
      temparr.end_user = data.end_user.toString()
      orderitemArray.push(temparr)
      data?.attachments.forEach((data2: any, _index2: any) => {
        if (data?.attachments?.length > -1) {
          const temp = data2?.file_r.split(',')

          if (temp[1] != undefined) orderitemArray[_index]!.attachments[_index2]!.file_r = temp[1]
        }
      })
    })
    let custcode: any = ''
    if (!isAdmin) custcode = localStorage.getItem('cust-code')!
    else custcode = customerID

    let custgroup: any = ''
    if (!isAdmin) custgroup = localStorage.getItem('cust-group')!
    else custgroup = customerGroup

    let payload = {}
    if (showPurchaseForm) {
      payload = {
        regarding: regarding,
        order_submissions: orderitemArray,
        customer_code: custcode,
        customer_account_group: custgroup,
        distribution_channel: disctribution,
        attachments: headerArray,
        lang: language,
        non_sales_regarding: regarding == 'PO002' ? nonpenjualan : undefined,
      }
    } else {
      payload = {
        regarding: regarding,
        order_submissions: orderitemArray,
        customer_code: custcode,
        customer_account_group: custgroup,
        distribution_channel: disctribution,
        attachments: headerArray,
        lang: language,
        non_sales_regarding: nonpenjualan,
      }
    }

    await createOrder(payload)
      .then((response) => {
        if (!response.data.error) {
          sessionStorage.setItem('po', response.data.data.id)
          swal({
            closeOnClickOutside: false,
            title: `${t('Order Created Successfully')}`,
            icon: 'success',
          }).then(() => {
            setIsSubmit(true)
            navigate('/management/order/all')
          })
        }
      })
      .catch((error) => {
        if (error.message == 'Network Error') {
          swal({
            closeOnClickOutside: false,
            title: 'Gateway Timeout',
            icon: 'error',
          })
        } else {
          swal({
            closeOnClickOutside: false,
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
        setDisable(false)
      })
    setBtnLoading(false)
    setDisable(false)
  }

  const [tempFiles, setTempFiles] = useState<any[]>([])

  const [uploadType, setUploadType] = useState('')
  const [orderItemFiles, setOrderItemsFiles] = useState<any[]>([])

  const handleUploadOrderItem = (item: any) => {
    setTempData(item)
    setOrderItemsFiles(item?.attachments)
    setUploadType('order-item')
    setShow1(true)
  }

  const getBase64 = (file: any) => {
    // console.log(file.name)
    setNamaFile(file.name)
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      setFiles(reader.result)
    }
    reader.onerror = function (error) {
      alert('Error: ' + error)
    }
  }

  function download_file(fileURL: any, fileName: any) {
    const [header, base64] = fileURL.split(",");
    const mime = header.match(/:(.*?);/)[1];

    const blob = base64ToBlob(base64, mime);
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, "_blank");
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate1 = document.getElementById('isPrivate1') as HTMLInputElement
    if (inputPrivate1 != null) inputPrivate1.checked = false

    const inputPrivate2 = document.getElementById('isPrivate2') as HTMLInputElement
    if (inputPrivate2 != null) inputPrivate2.checked = false
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const clearInputJadwal = () => {
    const input1 = document.getElementById('jadwalminggu') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('jadwalbulan') as HTMLSelectElement
    input2.selectedIndex = 0
    const input3 = document.getElementById('jadwaltahun') as HTMLSelectElement
    input3.selectedIndex = 0
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    input4.value = ''
    const input5 = document.getElementById('jadwaltanggal') as HTMLSelectElement
    input5.selectedIndex = 0
  }

  const [fileHeader, setFileHeader] = useState<any[]>([])

  const handleUpload = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: files,
        name: namaFile,
        description: description,
        file_type: dataType,
        private: isPrivate,
        roles: temparray,
      }
      let tempArray = [...fileHeader]
      tempArray.push(tempObject)

      setFileHeader(tempArray)
      // setShow1(false)
      removeFileState()
      clearInputUpload()
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const handleDeleteUploadHeader = (
    index: any,
    data: any,
    setData: any,
    type: any,
    datafull: any,
    setdatafull: any
  ) => {
    if (type == 'header') {
      // const tempArray = [...data]
      // console.log(tempArray)
      // tempArray.splice(index, 1)
      // setData(tempArray)
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            tempArray.splice(index, 1)
            setData(tempArray)
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    } else {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            const tempfull = datafull
            tempArray?.splice(index, 1)
            tempfull.attachments = tempArray
            setData(tempArray)
            setdatafull(tempfull)
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    }
  }

  const fieldClearer = (status: any) => {
    if (status > 0) {
      const hargap = document.getElementById('hargap') as HTMLInputElement
      if (hargap != null) hargap!.value = ''
      setSubprice(0)
      const kuantum = document.getElementById('kuantum') as HTMLInputElement
      if (kuantum != null) kuantum!.value = ''
      setQuantum(0)
      const radio1 = document.getElementById('exclude') as HTMLInputElement
      if (radio1 != null) radio1.checked = false
      const radio2 = document.getElementById('include') as HTMLInputElement
      if (radio2 != null) radio2.checked = true
      setPPN('include')
      const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
      if (ckbox != null) ckbox.checked = false
      const shipping = document.getElementById('shipping') as HTMLInputElement
      if (shipping != null) shipping!.value = ''
      setShipping(0)

      if (status > 1) {
        setPname('')
        setPnumber('')
        setFullProductName([])
        if (status > 2) {
          const jenis = document.getElementById('jenis') as HTMLSelectElement
          if (jenis != null) jenis!.selectedIndex = 0
          setPtype('')
          setPtype2('')
          if (status > 3) {
            setWarehouse('')
            setWarehouseDesc('')
            setPlantcity('')
            if (status > 4) {
              setCity(0)
              setCityDesc('')
              setFullCity([])
              if (status > 5) {
                setProvince(0)
                setProvinceDesc('')
                setCountry('')
                setCountryDesc('')
                if (status > 6) {
                  const note = document.getElementById('note') as HTMLInputElement
                  if (note != null) note!.value = ''
                  setNote('')
                  const pay1 = document.getElementById('payment1') as HTMLSelectElement
                  if (pay1 != null) pay1!.selectedIndex = 0
                  const pay2 = document.getElementById('payment2') as HTMLSelectElement
                  if (pay2 != null) pay2!.selectedIndex = 0
                  setPay1('')
                  setPay2('')
                  setPay1Desc('')
                  setPay2Desc('')
                  const enduser = document.getElementById('enduser') as HTMLInputElement
                  if (enduser != null) enduser!.value = ''
                  const enduser2 = document.getElementById('enduser2') as HTMLSelectElement
                  if (enduser2 != null) enduser2!.selectedIndex = 0
                  setEnduser('')
                  setEnduserDesc('')
                  setEnduserArray([])
                  setIsNoEnduser(false)

                  const spek = document.getElementById('spek') as HTMLInputElement
                  if (spek != null) spek!.value = ''
                  setPspec('')
                  const keterangan = document.getElementById('keterangan') as HTMLInputElement
                  if (keterangan != null) keterangan!.value = ''
                  const segmen = document.getElementById('segment') as HTMLInputElement
                  if (segmen != null) segmen!.value = ''
                  setSegment('')
                  setSegmentDesc('')
                  setketerangan('')
                  setIncoterm1(0)
                  setIncoterm2(0)
                  setIncoterm1Desc(0)
                  setIncoterm2Desc(0)
                  if (status > 7) {
                    if (idSektor != 3) {
                      const sektor = document.getElementById('sektor') as HTMLSelectElement
                      if (sektor != null) sektor!.selectedIndex = 0
                      setIDSector(0)
                      setSektorDesc('')
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else if (status == 'province') {
      setCity(0)
      setCityDesc('')
    } else if (status == 'tipe') {
      setPname('')
      setPnumber('')
    } else if (status == 'warehouse') {
      setPname('')
      setPnumber('')
      setFullProductName([])
      const jenis = document.getElementById('jenis') as HTMLSelectElement
      if (jenis != null) jenis!.selectedIndex = 0
      setPtype('')
      setPtype2('')
    }
  }

  const handleDeleteItems = (index: any, data: any, setData: any, data2: any, setData2: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((del) => {
      if (del) {
        const tempArray = [...data]
        const tempArray2 = [...data2]
        tempArray.splice(index, 1)
        tempArray2.splice(index, 1)
        setData(tempArray)
        setData2(tempArray2)
        if (tempArray.length == 0) setAttachmentIDSector(0)
        swal({
          closeOnClickOutside: false,
          title: t('deleted successfully'),
          icon: 'success',
        })
      }
    })
  }

  const handleUpload2 = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: files,
        name: namaFile,
        description: description,
        file_type: dataType,
        private: isPrivate,
        roles: temparray,
      }
      let tempArray = [...submitOrder]
      let temp: any[] = tempData?.attachments
      if (temp == null) {
        const temp2 = []
        temp2.push(tempObject)
        temp = temp2
      } else {
        temp.push(tempObject)
      }
      // tempArray.push(tempObject);
      tempArray[index2].attachments = temp

      setSubmitOrder(tempArray)
      // setShow1(false)
      clearInputUpload()
      removeFileState()
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const validasiFile = () => {
    if (files == null || files == '') return 'File'
    else if (description == '') return 'File Information'
    else return 'nothing'
  }

  const removeFileState = () => {
    setFiles('')
    setNamaFile('')
    setDescription('')
    setDataType('')
    setTempRole([])
    setIsPrivate(false)
  }

  const separateValue = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
  }

  const separateValue3 = (state: any, value: any, desc: any, name: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
    name(temp[2])
  }

  const separateValue2 = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(parseInt(temp[0]))
    desc(temp[1])
  }

  const [disableCKBOX, setDisableCKBOX] = useState(false)

  const separateValue4 = (value: any, state: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
    if (temp[0] != 0) setDisableCKBOX(true)
    else setDisableCKBOX(false)

    // console.log(temp[0], temp[1])
  }

  const getSectorDesc = (id: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    id(temp[0])
    desc(temp[2])
  }

  const priceListData = async () => {
    let cred: any = ''
    if (!isAdmin) cred = localStorage.getItem('cust-code')
    else cred = customerID
    if (pnumber != '' && regarding != 'PO002') {
      await getPriceList(cred, produsen, pnumber, city, warehouse, incoterm1Desc, punit).then((res) => {
        setSubprice(res.data.data)
      })
    }
  }

  const loadDetailCust = async (item: any) => {
    setCustSelect(item)

    try {
      await getCustomerDt(item?.customer_code).then((res: any) => {
        setAvailableSectors(res.data.data?.user?.sectors?.join("|"))
      })
    }catch(e){
      setCustSelect(null)
    }
  }

  //#region
  CustomUseEffect(() => {
    if (retailFlag) priceListData()
    else return
  }, [produsen])

  CustomUseEffect(() => {
    const priceListData2 = async () => {
      let cred: any = ''
      if (!isAdmin) cred = localStorage.getItem('cust-code')
      else cred = customerID
      if (
        produsen &&
        city &&
        warehouse &&
        incoterm1Desc &&
        pnumber != '' &&
        nonPenjualanFlag != 'form2'
      ) {
        setLoadingPrice(true)
        await getPriceList(cred, produsen, pnumber, city, warehouse, incoterm1Desc, punit)
          .then((res) => {
            setSubprice(res.data.data)
          })
          .catch((error) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
          })
        setLoadingPrice(false)
      }
    }
    if (retailFlag) {
      setSubprice(0)
      priceListData2()
    } else return
    }, [produsen, pnumber, city, warehouse, incoterm1Desc])
  // }, [pnumber])

  CustomUseEffect(() => {
    if (retailFlag) {
      setSubprice(0)
      priceListData()
    } else return
  }, [city])
  //#endregion

  CustomUseEffect(() => {
    const productNameData = async () => {
      setPname('')
      setPnumber('')
      setFullProductName([])
      let tempwarehouse = ''
      let options = {}
      if (isRetail(idSektor)) {
        tempwarehouse = warehouse
        let ccode = ""
        if(isAdmin){
          ccode = customerID + ""
        }else{
          ccode = localStorage.getItem('cust-code') || ""
        }
        options = {
          city,
          incoterm: incoterm1Desc,
          customer_code: ccode || "",
        }
      }
      
      // if(!disctribution || !ptype || !produsen || !idSektor) return
      setLoadingPrice(true)
      await getProductName(tempwarehouse, disctribution, ptype, produsen, idSektor, options).then(
        (res) => {
          if(res.data.data.length == 0){
            setPname('')
            setPnumber('')
          }
          setFullProductName(
            res.data.data.map((item: any) => {
              return {
                value: [
                  item.material_number,
                  item.material_description,
                  item.base_of_measure,
                ].join('~#~'),
                label: parseInt(item.material_number) + " - " + item.material_description,
                truevalue: parseInt(item.material_number),
              }
            })
          )
          setLoadingPrice(false)
        }
      )
    }
    productNameData()
  }, [warehouse, disctribution, ptype, idSektor, incoterm1Desc])

  CustomUseEffect(() => {
    reloadData()
    getprov()
    if (localStorage.getItem('cust-group') == 'AR06') plantData()
  }, [produsen, idSektor])

  CustomUseEffect(() => {
    plantData()
  }, [province, country, city])

  CustomUseEffect(() => {
    let cred: any = ''
    if (!isAdmin) cred = localStorage.getItem('cust-code')
    else cred = customerID
    const paymentData = async () => {
      await getAllPaymentList(idSektor).then((res) => {
        setFullPayment(res.data.data)
      })
    }

    paymentData()
  }, [idSektor])

  CustomUseEffect(() => {
    setNonPenjualanFlag('')
    setNonPenjualan('')
  }, [regarding])

  CustomUseEffect(() => {
    setSubmitDesc([])
    setSubmitOrder([])
    setFileHeader([])
  }, [nonpenjualan])

  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)

  useEffect(() => {
    if (localStorage.getItem('cust-group') == 'AR06') {
      setIDSector(3)
      setSektorDesc('Export')
    }
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDay(today.getDate())
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDateNow(dd + '-' + mm + '-' + yyyy)
    setDaysInMonth(getDaysInMonth(today.getFullYear(), today.getMonth() + 1))

    const getNonSalesList = async () => {
      const res = await nonSalesList()
      setListNonSales(res.data)
    }

    const handleYear = () => {
      let year = []
      const aYearFromNow = new Date()
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
      for (let i = 0; i < 2; i++) {
        year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
      }
      setListYear(year)
    }
    const getCustomer = async () => {
      const res = await axios.get(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/customer/detail?customer_code=${localStorage.getItem('cust-code')}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      setDetailCust(res.data.data)
    }
    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      // console.log(res.data.data, 'all rolelist')
      setFullRole(res.data.data)
    }

    getAccessMenu()
    handleYear()
    getCustomer()
    getNonSalesList()
    getAllRoleList()
  }, [])

  const handleLoading = (loading: any) => {
    if (loading) {
      return <Spinner animation='border' size='sm' />
    } else {
      if (isRetail(idSektor)) return t('Submit')
      else if ((idSektor == 1 || idSektor == 3) && showPurchaseForm) return t('Kirim Order')
      else return t('Submit')
    }
  }

  const handleCustomer = async () => {
    await getCustomer('', '').then((res: any) => {
      setFullCustomer(res.data.data.data)
      setNumberURL(res.data.data.links)
      setBrowseCust(true)
    })
  }

  const [loadingpage, setLoadingPage] = useState(false)

  const [numberURL, setNumberURL] = useState([])

  const paginateNumber = async (number: any) => {
    setLoadingPage(true)
    const customer_code = customerFilter?.customer_code ?? ''
    const name = customerFilter?.name ?? ''
    const res = await axios.get(`${number}&customer_code=${customer_code}&name=${name}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
    setFullCustomer(res.data.data.data)
    dispatch(setCustomerList(res.data.data.data))
    setNumberURL(res.data.data.links)
    dispatch(setNumberUrls(res.data.data.links))
    setLoadingPage(false)
  }

  const [browseCust, setBrowseCust] = useState(false)
  const [fullCustomer, setFullCustomer] = useState<any[]>([])
  const [customer, setCustomer] = useState('')
  const [customerID, setCustomerID] = useState(0)
  const [customerGroup, setCustomerGroup] = useState('')
  const [custSelect, setCustSelect] = useState<any>({})
  // console.log(custSelect, 'custSelect')

  const [custName, setCustName] = useState('')
  const [custNum, setCustNum] = useState('')
  const [detailCust, setDetailCust] = useState<any>({})

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getCustomer(customerFilter?.customer_code ?? '', customerFilter?.name ?? '').then(
        (res: any) => {
          setFullCustomer(res.data.data.data)
          dispatch(setCustomerList(res.data.data.data))
          setNumberURL(res.data.data.links)
          dispatch(setNumberUrls(res.data.data.links))
        }
      )
    }, 1000)

    return () => clearTimeout(getData)
  }, [customerFilter, dispatch])

  const [roleUser] = useState(localStorage.getItem('role-flag')!)
  const [fullOrder, setFullOrder] = useState<any>([])

  const isAdmin = roleUser == 'salesAdmin' || roleUser == 'admin'

  const onFetchAmandements = useCallback(() => {
    if (regarding !== 'PO003') return
    setLoadingPage(true)

    const is_amandemen = false

    let custcode: any = ''
    if (!isAdmin) custcode = localStorage.getItem('cust-code')!
    else custcode = customerID

    fetchAmandements({...filterAmandement, is_amendment: is_amandemen, customer_code: custcode}).then((res) => {
      setFullOrder(res.data.data.data)
      setNumberURL2(res.data.data.links)
      setLoadingPage(false)
    })
  }, [filterAmandement, regarding, roleUser, customerID])

  useEffect(() => {
    const getData = setTimeout(onFetchAmandements, 1000)
    return () => clearTimeout(getData)
  }, [onFetchAmandements])

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const [numberURL2, setNumberURL2] = useState([])

  const paginateNumber2 = async (number: any) => {
    setLoadingPage(true)

    const is_amandemen = isAdmin ? true : false
    const token = localStorage.getItem('token') as string
    const credentials = localStorage.getItem('credential') as string
    const endpoint = `${number}&credentials=${credentials}&is_amendment=${is_amandemen}&${objToParams(
      filterAmandement
    )}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setFullOrder(res.data.data.data)
    setNumberURL2(res.data.data.links)
    setLoadingPage(false)
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleShowValueLokasi = (item: any, type: any) => {
    let temp = ''
    if (type == 'city') {
      item.forEach((element: any, index: any) => {
        if (index + 1 == item.length) temp = temp + element.city?.city_name
        else temp = temp + element.city?.city_name + ', '
      })
    } else {
      item.forEach((element: any, index: any) => {
        if (index + 1 == item.length) temp = temp + element.province?.region_name
        else temp = temp + element.province?.region_name + ', '
      })
    }
    return temp
  }

  CustomUseEffect(() => {
    submitOrder.forEach((element: any, index: any) => {
      const td1 = document.getElementById('height' + index)
      const action = document.getElementById('targetAction' + index)
      if (td1 && action) {
        const heightTd2 = td1?.clientHeight + 2
        action.style.height = heightTd2 + 'px'
      }
    })
  }, [submitOrder.length])

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const [loadingPrice, setLoadingPrice] = useState(false)

  const nonPurchaseButPurchase = (regarding == 'PO002' && ['INF-201', 'INF-202'].includes(nonpenjualan))
  const showPurchaseForm = regarding == 'PO001' || nonPurchaseButPurchase
  const enableAddProduct = (regarding == 'PO002' && nonpenjualan != '') || regarding == 'PO001'
  const enableSendOrder = enableAddProduct && submitOrder.length > 0
  const hakAkses = HakAkses();

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('page create order')}</PageTitle>
      {!loading ? (
        <div className='card'>
          {/* begin::Header */}
          <div className='card-body mt-3'>
            <Row>
              <Col md='5'>
                <Row className='mb-3'>
                  <Col md='5'>
                    <p className='fs-4 mt-2'>
                      {t('order-perihal')}
                      <span className='text-danger'>*</span>
                    </p>
                  </Col>
                  <Col md='7'>
                    {isAdmin ? (
                      <Form.Select
                        aria-label='Default select example'
                        size='sm'
                        className='w-100'
                        onChange={(e: any) => {
                          clearState()
                          setOrderItemsFiles([])
                          setSubmitOrder([])
                          setSubmitDesc([])
                          setFileHeader([])
                          setRegarding(e.target.value)
                        }}
                      >
                        <option selected value=''>
                          {t('Pilih Perihal')}
                        </option>
                        <option value='PO001'>{t('penjualan')}</option>
                        <option value='PO002'>{t('Non-penjualan')}</option>
                        {
                          hakAkses?.update && <>
                            <option value='PO003'>{t('amandement')}</option>
                          </>
                        }
                      </Form.Select>
                    ) : (
                      <Form.Select
                        aria-label='Default select example'
                        size='sm'
                        className='w-100'
                        onChange={(e: any) => {
                          clearState()
                          setOrderItemsFiles([])
                          setSubmitOrder([])
                          setSubmitDesc([])
                          setFileHeader([])
                          setRegarding(e.target.value)
                        }}
                      >
                        <option selected value=''>
                          {t('Pilih Perihal')}
                        </option>
                        <option value='PO001'>{t('penjualan')}</option>
                        <option value='PO002'>{t('Non-penjualan')}</option>
                        <option value='PO003'>{t('amandement')}</option>
                      </Form.Select>
                    )}
                  </Col>
                </Row>
                {regarding == 'PO002' && (
                  <Row className='mb-3'>
                    <Col md='5'>
                      <p className='fs-4 mt-2'>
                        {t('Non-penjualan')}
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col md='7'>
                      <Form.Select
                        aria-label='Default select example'
                        size='sm'
                        className='w-100'
                        onChange={(e: any) =>
                          separateValue4(e.target.value, setNonPenjualan, setNonPenjualanFlag)
                        }
                      >
                        <option selected value=''>
                          {t('pilih')} {t('Non-penjualan')}
                        </option>
                        {listNonSales.map((item: any, index: number) => {
                          return (
                            <option key={item?.code ?? index} value={item.code + '~#~' + item.flag}>
                              {item.code} - {t(item.desc)}
                            </option>
                          )
                        })}
                      </Form.Select>
                    </Col>
                  </Row>
                )}
                {isAdmin && (
                  <Row className='mb-3'>
                    <Col md='5'>
                      <p className='fs-4 mt-2'>
                        {t('order-pembeli')}
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col md='7'>
                      <div className='d-flex align-items-center'>
                        <Form.Control disabled value={customer} size='sm' />
                        <Button
                          disabled={submitOrder.length > 0 ? true : false}
                          variant='primary'
                          className='ms-1 px-2'
                          size='sm'
                          onClick={() => handleCustomer()}
                        >
                          <KTSVG path='/media/icons/duotune/browse.svg' className='svg-icon-3 ms-2' />
                        </Button>
                        <Modal
                          show={browseCust}
                          onHide={() => setBrowseCust(false)}
                          centered
                          backdrop='static'
                          keyboard={false}
                          size='lg'
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{t('Browse')}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <TableBrowseCustomers
                              customers={fullCustomer}
                              paginateNumber={paginateNumber}
                              numberURL={numberURL}
                              onSelectCustomer={(item) => {
                                if (!item) return
                                setCustomer(item?.name as string)
                                setCustomerID(Number(item?.customer_code as string))
                                setCustomerGroup(item?.customer_account_group as string)

                                if (item.customer_account_group == 'AR06') {
                                  setIDSector(3)
                                  setSektorDesc('Export')
                                  localStorage.setItem('cust-group', 'AR06')
                                } else {
                                  localStorage.setItem('cust-group', item.customer_account_group!)
                                }
                                setBrowseCust(false)
                                // setCustSelect(item)
                                loadDetailCust(item)
                              }}
                            />
                          </Modal.Body>
                        </Modal>
                      </div>
                    </Col>
                  </Row>
                )}
                {!isSubmit && !isAdmin && (
                  <Row hidden={regarding == 'PO002' ? true : false} className='mb-3'>
                    <Col md='5'>
                      <p className='fs-4 mt-2'>{t('order-lampiran')}</p>
                    </Col>
                    <Col md='7'>
                      <Button
                        variant='primary'
                        onClick={() => {
                          handleShow1()
                          removeFileState()
                          setUploadType('header')
                        }}
                        className='w-100'
                        disabled={!enableAddProduct}
                      >
                        <i className='fa fa-file'></i>
                        {t('order-lampiranUpload')}
                      </Button>
                    </Col>
                  </Row>
                )}
                {isAdmin ? (
                  <>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('PIC Customer')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={custSelect?.name4} disabled size='sm' />
                      </Col>
                    </Row>
                    {!isSubmit && (
                      <Row hidden={regarding == 'PO002' ? true : false} className='mb-3'>
                        <Col md='5'>
                          <p className='fs-4 mt-2'>{t('order-lampiran')}</p>
                        </Col>
                        <Col md='7'>
                          <Button
                            variant='primary'
                            onClick={() => {
                              handleShow1()
                              removeFileState()
                              setUploadType('header')
                            }}
                            className='w-100'
                            disabled={!enableAddProduct}
                          >
                            <i className='fa fa-file'></i>
                            {t('order-lampiranUpload')}
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </>
                ) : (
                  <>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('PIC Customer')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={detailCust?.name4} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Address')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          as='textarea'
                          value={detailCust?.address?.street1}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row hidden={regarding == 'PO002' ? false : true} className='mb-3'>
                      <Col md='5'>
                        <p className='fs-4 mt-2'>{t('order-lampiran')}</p>
                      </Col>
                      <Col md='7'>
                        <Button
                          variant='primary'
                          disabled={!enableAddProduct}
                          onClick={() => {
                            handleShow1()
                            removeFileState()
                            setUploadType('header')
                          }}
                          className='w-100'
                        >
                          <i className='fa fa-file'></i>
                          {t('order-lampiranUpload')}
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
              <Col md='7'>
                {isAdmin ? (
                  <>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={custSelect?.customer_code}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={custSelect?.name} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Phone Number')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={custSelect?.name4} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Email')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={custSelect?.email} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Address')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          as='textarea'
                          value={custSelect?.address?.street1}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={detailCust?.customer_code}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={detailCust?.name} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Phone Number')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={detailCust?.contact?.no_telp}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Email')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={detailCust?.contact?.email}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
            </Row>
          </div>
          <hr/>
          <div className='card-body'>
            {!isSubmit ? (
              <div className='d-flex justify-content-end'>
                <>
                {enableAddProduct ? (
                    <Button
                      className='btn btn-primary'
                      onClick={() => {
                        clearState()
                        handleShow2()
                      }}
                      disabled={isAdmin && customerID == 0 ? true : false}
                    >
                      <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                      {t('tambah-produk')}
                    </Button>
                  ) : (
                    <Button className='btn btn-primary' disabled hidden={regarding == 'PO003'}>
                      <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                      {t('tambah-produk')}
                    </Button>
                  )}
                  <Modal
                    show={show2}
                    onHide={handleClose2}
                    backdrop='static'
                    keyboard={false}
                    centered
                    scrollable={showPurchaseForm ? true : false}
                    size='xl'
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t('tambah-produk')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {showPurchaseForm ? (
                        <>
                          {idSektor == 3 ? (
                            <Row>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('kontrak-produsen')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      id='produsen'
                                      placeholder={t('pilih')}
                                      onChange={(e: any) => {
                                        separateValue3(
                                          setProdusen,
                                          e?.value,
                                          setDistribution,
                                          setProdusenDesc
                                        )
                                        fieldClearer(8)
                                      }}
                                      options={salesArea}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('sub-order-incoterm1')}
                                      <span className='text-danger'>*</span>
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      key={produsen + idSektor}
                                      placeholder={t('pilih')}
                                      id='incoterm1'
                                      onChange={(e: any) =>
                                        separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                      }
                                      options={fullIncoterm}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>
                                      {t('sub-order-provinsi')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      key={idSektor + produsen}
                                      placeholder={t('pilih')}
                                      id='provinsi'
                                      onChange={(e: any) => cityData(e?.value)}
                                      options={fullProvince}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('sub-order-jenis')}
                                      <span className='text-danger'>*</span>
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='jenis'
                                      onChange={(e: any) => productTypeChange(e.target.value)}
                                    >
                                      <option hidden value='~#~'>
                                        {t('Pilih-productType')}
                                      </option>
                                      {fullProductType.map((item: any) => {
                                        return (
                                          <>
                                            {item.id != 12 && (
                                              <option
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            )}
                                          </>
                                        )
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>
                                {parseInt(pnumber) == 0 && (
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6'>
                                        Custom Product Name<span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        placeholder=' Custom Product Name'
                                        size='sm'
                                        aria-label='Default select example'
                                        type='text'
                                        id='custom'
                                        onChange={(e: any) => setPname(e.target.value)}
                                      />
                                    </Col>
                                  </Row>
                                )}
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('Kuantum Pengajuan')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <CurrencyInput
                                        className='form-control form-control-sm'
                                        id='kuantum'
                                        // key={pname}
                                        placeholder={t('Kuantum Pengajuan')}
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setQuantum(value?.replace(/,/g, '.'))
                                        }}
                                        decimalsLimit={2}
                                      />
                                      <InputGroup.Text id='basic-addon2'>MT</InputGroup.Text>
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row className='mb-1'>
                                  <Col sm={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup className='mb-3'>
                                      <Form.Control
                                        size='sm'
                                        type='number'
                                        id='shipping'
                                        placeholder={t('Shipping Tolerance')}
                                        onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                      />
                                      <InputGroup.Text
                                        id='basic-addon2'
                                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                                      >
                                        <span style={{padding: '0 3px'}}>%</span>
                                      </InputGroup.Text>
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('sub-order-payment1')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='payment1'
                                      onChange={(e: any) =>
                                        separateValue(setPay1, e.target.value, setPay1Desc)
                                      }
                                    >
                                      <option hidden value='~#~'>
                                        {t('Pilih-payment')}
                                      </option>
                                      {fullPayment.map((item: any) => {
                                        return (
                                          <>
                                            <option value={item.code + '~#~' + item.payment_desc}>
                                              {item.payment_desc}
                                            </option>
                                          </>
                                        )
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('keterangan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('keterangan')}
                                      defaultValue={test?.payment_note}
                                      id='keterangan'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setketerangan(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('End Customer')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      size='sm'
                                      as='textarea'
                                      id='enduser'
                                      style={{height: '40px'}}
                                      placeholder={t('End Customer')}
                                      onChange={(e: any) => {
                                        setEnduser(e.target.value)
                                        setEnduserDesc(e.target.value)
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>
                                      {t('sub-order-sektor')}
                                      <span className='text-danger'>*</span>
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    {localStorage.getItem('cust-group') != 'AR06' ? (
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='sektor'
                                        onChange={(e: any) => {
                                          setSektor(e.target.value)
                                          getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                          fieldClearer(7)
                                        }}
                                      >
                                        <option hidden value={0 + ';;'}>
                                          {t('Pilih-sector')}
                                        </option>
                                        {fullSector.map((item: any, index) => {
                                          return (
                                            <option
                                              key={item?.id ?? index}
                                              value={item.id + '~#~' + '' + '~#~' + item.name}
                                            >
                                              {t(item.name)}
                                            </option>
                                          )
                                        })}
                                      </Form.Select>
                                    ) : (
                                      <Form.Control type='text' value='Export' size='sm' disabled />
                                    )}
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      key={produsen + idSektor}
                                      placeholder={t('pilih')}
                                      id='incoterm2'
                                      onChange={(e: any) => {
                                        separateValue2(setIncoterm2, e?.value, setIncoterm2Desc)
                                      }}
                                      options={fullIncoterm2}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      key={province}
                                      placeholder={t('pilih')}
                                      id='kota'
                                      isDisabled={false}
                                      onChange={(e: any) => {
                                        separateValue2(setCity, e?.value, setCityDesc)
                                        // fieldClearer(4)
                                      }}
                                      options={fullCity}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>
                                      {t('sub-order-produk')}
                                      <span className='text-danger'>*</span>
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      id='produk'
                                      key={ptype}
                                      placeholder={t('pilih')}
                                      onChange={(e: any) => {
                                        productNameChange(e?.value)
                                        // fieldClearer(1)
                                      }}
                                      options={fullProductName}
                                    />
                                  </Col>
                                </Row>
                                {parseInt(pnumber) == 0 && (
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        as='textarea'
                                        placeholder={t('sub-order-catatan')}
                                        id='note'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => setNote(e.target.value)}
                                      />
                                    </Col>
                                  </Row>
                                )}

                                <Row className='mb-2'>
                                  <Col sm={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>
                                      {t('Harga Pengajuan')}/MT
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <InputGroup.Text id='basic-addon2'>
                                        <span className='px-2'>USD</span>
                                      </InputGroup.Text>
                                      <CurrencyInput
                                        className='form-control form-control-sm'
                                        id='hargap'
                                        key={formulaPrice.toString()}
                                        disabled={formulaPrice}
                                        placeholder={formulaPrice ? '0' : t('Harga Pengajuan')}
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setSubprice(value?.replace(/,/g, '.'))
                                        }}
                                        decimalsLimit={2}
                                      />
                                    </InputGroup>
                                  </Col>
                                </Row>

                                <Row className='mb-4'>
                                  <Col sm={4} className='d-flex align-items-center'>
                                    <p className=' fs-6'>{t('Formulated Price')}</p>
                                  </Col>
                                  <Col
                                    sm={8}
                                    className='d-flex justify-content-start align-items-center'
                                  >
                                    <Form.Check
                                      reverse
                                      name='formula_Price'
                                      className='mt-5 mb-2'
                                      type='checkbox'
                                      onClick={() => {
                                        setFormulaPrice(!formulaPrice)
                                      }}
                                      id='formula_Price'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='payment2'
                                      onChange={(e: any) =>
                                        separateValue(setPay2, e.target.value, setPay2Desc)
                                      }
                                    >
                                      <option value='~#~'>{t('Pilih-payment')}</option>
                                      {fullPayment.map((item: any, index: number) => {
                                        return (
                                          <option
                                            key={item?.code ?? index}
                                            value={item.code + '~#~' + item.payment_desc}
                                          >
                                            {item.payment_desc}
                                          </option>
                                        )
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-spek')}
                                      id='spek'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setPspec(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                                {parseInt(pnumber) == 0 ? (
                                  <></>
                                ) : (
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        as='textarea'
                                        placeholder={t('sub-order-catatan')}
                                        id='note'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => setNote(e.target.value)}
                                      />
                                    </Col>
                                  </Row>
                                )}
                              </Col>
                            </Row>
                          ) : (
                            <>
                              <Row>
                                <Col md={6}>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('kontrak-produsen')}
                                        <span className='text-danger'>*</span>{' '}
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='produsen'
                                        placeholder={t('pilih')}
                                        onChange={(e: any) => {
                                          separateValue3(
                                            setProdusen,
                                            e?.value,
                                            setDistribution,
                                            setProdusenDesc
                                          )
                                          fieldClearer(8)
                                        }}
                                        options={salesArea}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col md={6}>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-sektor')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      {localStorage.getItem('cust-group') != 'AR06' ? (
                                        <Select
                                        isDisabled={loadingSektor}
                                        id='sektor'
                                        placeholder={t('Pilih-sector')}
                                        onChange={(e: any) => {
                                          setSektor(e.value)
                                            getSectorDesc(
                                              setIDSector,
                                              e.value,
                                              setSektorDesc
                                            )
                                            fieldClearer(7)
                                        }}
                                        options={fullSector.map((item: any, index: number) => {
                                          return {
                                            value: item.id + '~#~' + '' + '~#~' + item.name,
                                            label: t(item.name)
                                          }
                                        })}
                                      />
                                      ) : (
                                        <Form.Control
                                          type='text'
                                          value='Export'
                                          size='sm'
                                          disabled
                                        />
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              {isRetail(idSektor) ? (
                                <FormCreateRetail
                                    separateValue3={separateValue3}
                                    fieldClearer={fieldClearer}
                                    separateValue2={separateValue2}
                                    separateValue={separateValue}
                                    getSectorDesc={getSectorDesc}
                                    cityData={cityData}
                                    productTypeChange={productTypeChange}
                                    setPname={setPname}
                                    setQuantum={setQuantum}
                                    setketerangan={setketerangan}
                                    setEnduser={setEnduser}
                                    setEnduserDesc={setEnduserDesc}
                                    setEnduserArray={setEnduserArray}
                                    setSektor={setSektor}
                                    productNameChange={productNameChange}
                                    setNote={setNote}
                                    setPspec={setPspec}
                                    plantChange={plantChange}
                                    setIDSector={setIDSector}
                                    setSektorDesc={setSektorDesc}
                                    setIncoterm1={setIncoterm1}
                                    setIncoterm1Desc={setIncoterm1Desc}
                                    setProdusen={setProdusen}
                                    setDistribution={setDistribution}
                                    setProdusenDesc={setProdusenDesc}
                                    setPay1={setPay1}
                                    setPay1Desc={setPay1Desc}
                                    setIncoterm2={setIncoterm2}
                                    setIncoterm2Desc={setIncoterm2Desc}
                                    setCity={setCity}
                                    setCityDesc={setCityDesc}
                                    setPay2={setPay2}
                                    setPay2Desc={setPay2Desc}
                                    salesArea={salesArea}
                                    idSektor={idSektor}
                                    produsen={produsen}
                                    pnumber={pnumber}
                                    language={language}
                                    test={test}
                                    arrayEnduser={arrayEnduser}
                                    roleUser={roleUser}
                                    province={province}
                                    ptype={ptype}
                                    city={city}
                                    subprice={subprice}
                                    pname={pname}
                                    isNoEnduser={isNoEnduser}
                                    loadingPrice={loadingPrice}
                                    fullProvince={fullProvince}
                                    fullProductType={fullProductType}
                                    fullIncoterm={fullIncoterm}
                                    fullPayment={fullPayment}
                                    fullEndUser={fullEndUser}
                                    fullSector={fullSector}
                                    fullIncoterm2={fullIncoterm2}
                                    fullCity={fullCity}
                                    fullProductName={fullProductName}
                                    fullPlant={fullPlant}
                                    setShipping={setShipping}
                                    setIsNoEnduser={setIsNoEnduser}
                                    setSubprice={setSubprice}
                                    setFormulaPrice={setFormulaPrice}
                                    setSegment={setSegment}
                                    setSegmentDesc={setSegmentDesc}
                                    formulaPrice={formulaPrice}
                                    fullSegment={fullSegment}
                                    cityDestinationData={cityDestinationData}
                                    setDestinationCity={setDestinationCity}
                                    setDestinationCityDesc={setDestinationCityDesc}
                                    fullDestinationCity={fullDestinationCity}
                                    fullProvinceDest={fullProvinceDest}
                                    setTransType={setTransType}
                                    setTransType2={setTransType2}
                                    setTransportasi={setTransportasi}
                                    fullTransport={fullTransport}
                                    setTransOptionType={setTransOptionType}
                                    transOptionType={transOptionType}
                                    fullTransportType={fullTransportType}
                                    setCommodity={setCommodity}
                                    commodity={commodity}/>
                              ) : (<FormCreateCorporation
                              separateValue3={separateValue3}
                              fieldClearer={fieldClearer}
                              separateValue2={separateValue2}
                              separateValue={separateValue}
                              getSectorDesc={getSectorDesc}
                              cityData={cityData}
                              productTypeChange={productTypeChange}
                              setPname={setPname}
                              setQuantum={setQuantum}
                              setShipping={setShipping}
                              setketerangan={setketerangan}
                              setEnduser={setEnduser}
                              setEnduserDesc={setEnduserDesc}
                              setEnduserArray={setEnduserArray}
                              setIsNoEnduser={setIsNoEnduser}
                              setSektor={setSektor}
                              productNameChange={productNameChange}
                              setNote={setNote}
                              setSubprice={setSubprice}
                              setFormulaPrice={setFormulaPrice}
                              setPspec={setPspec}
                              setIDSector={setIDSector}
                              setSektorDesc={setSektorDesc}
                              setIncoterm1={setIncoterm1}
                              setIncoterm1Desc={setIncoterm1Desc}
                              setProdusen={setProdusen}
                              setDistribution={setDistribution}
                              setProdusenDesc={setProdusenDesc}
                              setPay1={setPay1}
                              setPay1Desc={setPay1Desc}
                              setSegment={setSegment}
                              setSegmentDesc={setSegmentDesc}
                              setIncoterm2={setIncoterm2}
                              setIncoterm2Desc={setIncoterm2Desc}
                              setCity={setCity}
                              setCityDesc={setCityDesc}
                              setPay2={setPay2}
                              setPay2Desc={setPay2Desc}
                              salesArea={salesArea}
                              idSektor={idSektor}
                              produsen={produsen}
                              pnumber={pnumber}
                              language={language}
                              test={test}
                              arrayEnduser={arrayEnduser}
                              roleUser={roleUser}
                              province={province}
                              ptype={ptype}
                              formulaPrice={formulaPrice}
                              isNoEnduser={isNoEnduser}
                              fullProvince={fullProvince}
                              fullProductType={fullProductType}
                              fullIncoterm={fullIncoterm}
                              fullPayment={fullPayment}
                              fullSegment={fullSegment}
                              fullEndUser={fullEndUser}
                              fullSector={fullSector}
                              fullIncoterm2={fullIncoterm2}
                              fullCity={fullCity}
                              fullProductName={fullProductName}
                            /> )}
                            </>
                          )}

                        </>
                      ) : (
                        <>
                          {nonPenjualanFlag == 'form1' ? (
                            <>
                              <Row>
                                <Col md={6}>
                                  <Row className='mb-3'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('kontrak-produsen')}
                                        <span className='text-danger'>*</span>{' '}
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='produsen'
                                        placeholder={t('pilih')}
                                        onChange={(e: any) => {
                                          separateValue3(
                                            setProdusen,
                                            e?.value,
                                            setDistribution,
                                            setProdusenDesc
                                          )
                                          fieldClearer(8)
                                        }}
                                        options={salesArea}
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        Incoterm
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        key={produsen + idSektor}
                                        placeholder={t('pilih')}
                                        id='incoterm1'
                                        onChange={(e: any) =>
                                          separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                        }
                                        options={fullIncoterm}
                                      />
                                    </Col>
                                  </Row>
                                  {idSektor != 3 ? (
                                    <>
                                      <Row className='mb-4'>
                                        <Col sm={4}>
                                          <p className='mt-3 fs-6'>
                                            {t('sub-order-provinsi')}
                                            <span className='text-danger'>*</span>{' '}
                                          </p>
                                        </Col>
                                        <Col sm={8}>
                                          <Select
                                            id='provinsi'
                                            key={idSektor + produsen}
                                            placeholder={t('pilih')}
                                            onChange={(e: any) => {
                                              setFullCity([])
                                              cityData(e?.value)
                                            }}
                                            options={fullProvince}
                                          />
                                        </Col>
                                      </Row>
                                    </>
                                  ) : (
                                    ''
                                  )}

                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('sub-order-jenis')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='jenis'
                                        onChange={(e: any) => productTypeChange(e.target.value)}
                                      >
                                        <option hidden value='~#~'>
                                          {t('Pilih-productType')}
                                        </option>
                                        {fullProductType.map((item: any) => {
                                          return (
                                            <>
                                              {item.id != 12 && (
                                                <option
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              )}
                                            </>
                                          )
                                        })}
                                      </Form.Select>
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('Kuantum Pengajuan')}
                                        <span className='text-danger'>*</span>{' '}
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <InputGroup size='sm'>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='kuantum'
                                          // key={pname}
                                          placeholder={t('Kuantum Pengajuan')}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            setQuantum(value?.replace(/,/g, '.'))
                                          }}
                                          decimalsLimit={2}
                                        />
                                        <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('End Customer')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      {isNoEnduser || isRetail(idSektor) || idSektor == 3 ? (
                                        <Form.Control
                                          size='sm'
                                          as='textarea'
                                          style={{height: '40px'}}
                                          id='enduser'
                                          placeholder={t('End Customer')}
                                          onChange={(e: any) => {
                                            setEnduser(e.target.value)
                                            setEnduserDesc(e.target.value)
                                          }}
                                        />
                                      ) : (
                                        <MultiSelect
                                          options={fullEndUser?.map((item: any) => {
                                            return {label: item.name, value: item.name}
                                          })}
                                          value={arrayEnduser}
                                          onChange={(e: any) => setEnduserArray(e)}
                                          labelledBy='Select'
                                        />
                                      )}
                                    </Col>
                                  </Row>
                                  {idSektor == 1 && (
                                    <>
                                      <Row className='mb-4'>
                                        <Col sm={4}></Col>
                                        <Col sm={8} className='d-flex align-items-center'>
                                          <Form.Check
                                            onClick={() => setIsNoEnduser(!isNoEnduser)}
                                            name='noenduser'
                                            disabled={disableCKBOX}
                                            id='noenduser'
                                            className='mt-5 mb-2'
                                            type='checkbox'
                                          />
                                          {i18next.language == 'en' ? (
                                            <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                          ) : (
                                            <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                          )}
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </Col>
                                <Col md={6}>
                                  <Row className='mb-3'>
                                    <Col sm={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-sektor')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      {localStorage.getItem('cust-group') != 'AR06' ? (
                                        <Form.Select
                                          size='sm'
                                          aria-label='Default select example'
                                          id='sektor'
                                          onChange={(e: any) => {
                                            setSektor(e.target.value)
                                            getSectorDesc(
                                              setIDSector,
                                              e.target.value,
                                              setSektorDesc
                                            )
                                            fieldClearer(7)
                                          }}
                                        >
                                          <option hidden value={0 + ';;'}>
                                            {t('Pilih-sector')}
                                          </option>
                                          {filteredSector.map((item: any, index: number) => {
                                            return (
                                              <option
                                                key={item?.id ?? index}
                                                value={item.id + '~#~' + '' + '~#~' + item.name}
                                              >
                                                {t(item.name)}
                                              </option>
                                            )
                                          })}
                                        </Form.Select>
                                      ) : (
                                        <Form.Control
                                          type='text'
                                          value='Export'
                                          size='sm'
                                          disabled
                                        />
                                      )}
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        as='textarea'
                                        placeholder={t('sub-order-catatan')}
                                        id='note'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => setNote(e.target.value)}
                                      />
                                    </Col>
                                  </Row>

                                  {idSektor != 3 && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='mt-3 fs-6'>
                                          {t('sub-order-kota')}
                                          <span className='text-danger'>*</span>
                                        </p>
                                      </Col>
                                      <Col sm={8}>
                                        <Select
                                          id='kota'
                                          key={province}
                                          placeholder={t('pilih')}
                                          onChange={(e: any) => {
                                            separateValue2(setCity, e?.value, setCityDesc)
                                            // fieldClearer(4)
                                          }}
                                          options={fullCity}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-produk')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='produk'
                                        key={ptype}
                                        placeholder={t('pilih')}
                                        onChange={(e: any) => {
                                          productNameChange(e?.value)
                                          // fieldClearer(1)
                                        }}
                                        isDisabled={loadingPrice}
                                        options={fullProductName}
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-3'>
                                    <Col sm={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('Harga Pengajuan')}/{idSektor === 3 ? 'MT' : 'Ton'}
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      {loadingPrice ? (
                                        <div className='bg-secondary p-3'>
                                          <i className='fa fa-spin fa-spinner'></i>
                                        </div>
                                      ) : (
                                        <InputGroup size='sm'>
                                          <InputGroup.Text id='basic-addon2'>
                                            {idSektor != 3 ? (
                                              <span className='px-1'>Rp</span>
                                            ) : (
                                              <span className='px-2'>USD</span>
                                            )}
                                          </InputGroup.Text>
                                          <CurrencyInput
                                            className='form-control form-control-sm'
                                            id='hargap'
                                            // key={pname}
                                            placeholder={t('Harga Pengajuan')}
                                            decimalSeparator={language === 'en' ? '.' : ','}
                                            groupSeparator={language === 'en' ? ',' : '.'}
                                            onValueChange={(value: any) => {
                                              setSubprice(value?.replace(/,/g, '.'))
                                            }}
                                            decimalsLimit={2}
                                          />
                                        </InputGroup>
                                      )}
                                    </Col>
                                  </Row>
                                  {idSektor != 3 && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='mt-3 fs-6'>{t('termasuk-ppn')}</p>
                                      </Col>
                                      <Col sm={8} className='d-flex justify-content-start'>
                                        <Form.Check
                                          reverse
                                          name='ppn'
                                          className='mt-3 mb-2'
                                          type='checkbox'
                                          id='ckbox-ppn'
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <>
                              <Row className='mb-3'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('kontrak-produsen')}
                                    <span className='text-danger'>*</span>{' '}
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produsen'
                                    placeholder={t('pilih')}
                                    onChange={(e: any) => {
                                      separateValue3(
                                        setProdusen,
                                        e?.value,
                                        setDistribution,
                                        setProdusenDesc
                                      )
                                      fieldClearer(8)
                                    }}
                                    options={salesArea}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {localStorage.getItem('cust-group') != 'AR06' ? (
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='sektor'
                                      onChange={(e: any) => {
                                        setSektor(e.target.value)
                                        getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                        fieldClearer(7)
                                      }}
                                    >
                                      <option hidden value={0 + ';;'}>
                                        {t('Pilih-sector')}
                                      </option>
                                      {filteredSector.map((item: any, index: number) => {
                                        return (
                                          <option
                                            key={item?.id ?? index}
                                            value={item.id + '~#~' + '' + '~#~' + item.name}
                                          >
                                            {t(item.name)}
                                          </option>
                                        )
                                      })}
                                    </Form.Select>
                                  ) : (
                                    <Form.Control type='text' value='Export' size='sm' disabled />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-jenis')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='jenis'
                                    onChange={(e: any) => productTypeChange(e.target.value)}
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-productType')}
                                    </option>
                                    {fullProductType.map((item: any) => {
                                      return (
                                        <>
                                          {item.id != 12 && (
                                            <option
                                              value={
                                                item.material_group_desc + '~#~' + item.material_group
                                              }
                                            >
                                              {t(item.material_group_desc)}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('sub-order-produk')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produk'
                                    key={ptype}
                                    placeholder={t('pilih')}
                                    onChange={(e: any) => {
                                      productNameChange(e?.value)
                                      // fieldClearer(1)
                                    }}
                                    options={fullProductName}
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNote(e.target.value)}
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('End Customer')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {isNoEnduser || isRetail(idSektor) || idSektor == 3 ? (
                                    <Form.Control
                                      size='sm'
                                      as='textarea'
                                      style={{height: '40px'}}
                                      id='enduser'
                                      placeholder={t('End Customer')}
                                      onChange={(e: any) => {
                                        setEnduser(e.target.value)
                                        setEnduserDesc(e.target.value)
                                      }}
                                    />
                                  ) : (
                                    <MultiSelect
                                      options={fullEndUser?.map((item: any) => {
                                        return {label: item.name, value: item.name}
                                      })}
                                      value={arrayEnduser}
                                      onChange={(e: any) => setEnduserArray(e)}
                                      labelledBy='Select'
                                    />
                                  )}
                                </Col>
                              </Row>
                              {idSektor == 1 && (
                                <Row className='mb-4'>
                                  <Col sm={4} />
                                  <Col sm={8} className='d-flex align-items-center'>
                                    <Form.Check
                                      onClick={() => setIsNoEnduser(!isNoEnduser)}
                                      name='noenduser'
                                      disabled={disableCKBOX}
                                      id='noenduser'
                                      className='mt-5 mb-2'
                                      type='checkbox'
                                    />
                                    {i18next.language == 'en' ? (
                                      <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                    ) : (
                                      <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                    )}
                                  </Col>
                                </Row>
                              )}
                            </>
                          )}
                        </>
                      )}

                      <div className='d-flex justify-content-end'>
                        <Button disabled={loadingAddProduct} variant='primary' onClick={() => insertAddOrder()}>
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr075.svg'
                            className='svg-icon-3'
                          />
                          {t('order-kirim')}
                        </Button>
                      </div>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
            ) : (
              <></>
            )}

            {regarding == 'PO003' ? (
              <OrderAmandementTable
                paginate={paginateNumber2}
                numberUrls={numberURL2}
                isLoading={loadingpage}
                items={fullOrder}
                popoverProvinceContent={(item) => handleShowValueLokasi(item.children, 'province')}
                popoverCityContent={(item) => handleShowValueLokasi(item.children, 'city')}
                onExpandRow={handleOpen}
                onUpload={(id) => tampilUpload(id, 'header')}
                onDetailIconClick={(subitem) => {
                  setTempDetail(subitem)
                  setShowDetail2(true)
                }}
                onScheeduleIconClick={(subitem) => {
                  formattingTon(subitem.fixed_quantum)
                  setSektor(subitem.sector_id)
                  setProvinceDesc(subitem.province?.region_name)
                  setCityDesc(subitem.city?.city_name)
                  setPname(subitem.product_name)
                  sessionStorage.setItem('isCustomer', 'false')
                  sessionStorage.setItem('id', subitem.id)
                  setSubID(subitem.id)
                  setShow3(true)
                }}
                onAttachmentIconClick={(subitem) => {
                  formattingTon(subitem.fixed_quantum)
                  setSektor(subitem.sector_id)
                  setProvinceDesc(subitem.province?.region_name)
                  setCityDesc(subitem.city?.city_name)
                  setPname(subitem.product_name)
                  setIsFileBox(true)
                  tampilUpload(subitem.id, 'order-item')
                }}
              />
            ) : (
              <div className='table-responsive mt-5 bdr'>
                {/* Table Head */}
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    {showPurchaseForm ? (
                      <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                        <th className='td-order-4 text-center'>{t('order-aksi')}</th>
                        <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                        <th className='td-order-4 text-center'>{t('kontrak-produsen')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-incoterm')}</th>
                        <th className='td-order-3 text-center'>{t('sub-order-wilayah')}</th>
                        {submitOrder[0]?.sector_id == 1 && (
                          <th className='td-order-2 text-center'>{t('segment')}</th>
                        )}
                        <th className='td-order-3 text-center'>{t('End Customer')}</th>
                        <th className='td-order-2 text-center'>{t('Sector')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                        <th className='td-order-2 text-center'>{t('Product Code')}</th>
                        <th className='td-order-4 text-center'>{t('sub-order-produk')}</th>
                        <th className='td-order-3 text-center'>{t('sub-order-spek')}</th>
                        <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                        {isRetail(idSektor) ? (
                          <th className='td-order-2 text-center'>{t('Price')}</th>
                        ) : (
                          <th className='td-order-2 text-center'>{t('Harga Pengajuan')}</th>
                        )}
                        {submitOrder[0]?.sector_id == 1 && (
                          <th className='td-order-2 text-center'>Status {t('Price')}</th>
                        )}
                        {submitOrder[0]?.sector_id != null ||
                        submitOrder[0]?.sector_id != undefined ? (
                          <>
                            {isRetail(submitOrder[0]?.sector_id) ? (
                              <th className='td-order-3 text-center'>{t('sub-order-gudang')}</th>
                            ) : (
                              ''
                            )}
                          </>
                        ) : (
                          ''
                        )}
                        <th className='td-order-2 text-center'>{t('sub-order-catatan')}</th>
                        {/* <th className='td-order-2 text-center'>Status</th> */}
                      </tr>
                    ) : (
                      <>
                        {nonPenjualanFlag == 'form1' ? (
                          <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                            <th className='td-order-4 text-center'>{t('order-aksi')}</th>
                            <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                            <th className='td-order-4 text-center'>{t('kontrak-produsen')}</th>
                            <th className='td-order-2 text-center'>{t('sub-order-incoterm')}</th>
                            {submitOrder[0]?.sector_id != 3 ? (
                              <th className='td-order-3 text-center'>{t('sub-order-wilayah')}</th>
                            ) : (
                              ''
                            )}
                            <th className='td-order-3 text-center'>{t('End Customer')}</th>
                            <th className='td-order-2 text-center'>{t('Sector')}</th>
                            <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                            <th className='td-order-2 text-center'>{t('Product Code')}</th>
                            <th className='td-order-4 text-center'>{t('sub-order-produk')}</th>
                            <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                            <th className='td-order-2 text-center'>{t('Price')}</th>
                            {submitOrder[0]?.sector_id == 1 && (
                              <th className='td-order-2 text-center'>Status {t('Price')}</th>
                            )}
                            <th className='td-order-2 text-center'>{t('sub-order-catatan')}</th>
                          </tr>
                        ) : (
                          <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                            <th className='td-order-4 text-center'>{t('order-aksi')}</th>
                            <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                            <th className='td-order-4 text-center'>{t('kontrak-produsen')}</th>
                            <th className='td-order-2 text-center'>{t('Sector')}</th>
                            <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                            <th className='td-order-4 text-center'>{t('sub-order-produk')}</th>
                            <th className='td-order-2 text-center'>{t('sub-order-catatan')}</th>
                          </tr>
                        )}
                      </>
                    )}
                  </thead>
                  {showPurchaseForm ? (
                    <>
                      {submitOrder.map((item, _index) => (
                        <tbody key={item?.id ?? _index}>
                          <tr className='d-flex jusify-content-center w-100 align-items-center'>
                            <td className='td-order-4 text-center column'>
                              <div className='d-flex justify-content-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title='Detail'
                                  onClick={() => {
                                    setShowDetail(true)
                                    // console.log(submitDesc[_index]);
                                    setTempKontrakID(item.sector_id)
                                    setTest(submitDesc[_index])
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/file-text-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                {!isSubmit ? (
                                  <>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('ubah')}
                                      onClick={() => {
                                        setState(item, _index)
                                        setTempID(_index)
                                        setTempKontrakID(item.sector_id)
                                        setTest(submitDesc[_index])
                                      }}
                                    >
                                      <KTSVG
                                        // pencil
                                        path='/media/icons/duotune/pencil-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>

                                    <button
                                      onClick={() => {
                                        setIsFileBox(true)
                                        formattingTon(item.request_quantum)
                                        setSektor(item.sector_id)
                                        setProvinceDesc(submitDesc[_index]?.province_id)
                                        setCityDesc(submitDesc[_index]?.city_id)
                                        setPname(item.product_name)
                                        setIndex2(_index)
                                        removeFileState()
                                        handleUploadOrderItem(item)
                                      }}
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('order-lampiran')}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/archive-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {!isSubmit ? (
                                  <>
                                    {regarding == 'PO001' ? (
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('tambah_jadwal')}
                                        onClick={() => {
                                          formattingTon(item.request_quantum)
                                          setSektor(item.sector_id)
                                          setProvinceDesc(submitDesc[_index]?.province_id)
                                          setCityDesc(submitDesc[_index]?.city_id)
                                          setPname(item.product_name)
                                          // setQuantum(item.request_quantum)
                                          setIndex2(_index)
                                          handleJadwal(item)
                                        }}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/calendar-check-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                    ) : (
                                      <></>
                                    )}
                                    <button
                                      onClick={() =>
                                        handleDeleteItems(
                                          _index,
                                          submitOrder,
                                          setSubmitOrder,
                                          submitDesc,
                                          setSubmitDesc
                                        )
                                      }
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('Hapus')}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/trash-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </td>
                            <td className='td-order-1 text-center column' id={`height${_index}`}>
                              <span className='d-block py-3'>{_index + 1}</span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block py-3'>
                                {submitDesc[_index]?.sales_org_code}
                              </span>
                            </td>
                            {isRetail(item.sector_id) ? (
                              <>
                                {submitDesc[_index]?.incoterm2_id == 0 ||
                                submitDesc[_index]?.incoterm2_id == null ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block py-3'>
                                      {submitDesc[_index]?.incoterm1_id}-
                                      {submitDesc[_index]?.city_plant}
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block py-3'>
                                      {submitDesc[_index]?.incoterm1_id}-
                                      {submitDesc[_index]?.incoterm2_id}
                                    </span>
                                  </td>
                                )}
                              </>
                            ) : (
                              <>
                                {submitDesc[_index]?.incoterm2_id == 0 ||
                                submitDesc[_index]?.incoterm2_id == null ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block py-3'>
                                      {submitDesc[_index]?.incoterm1_id}
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block py-3'>
                                      {submitDesc[_index]?.incoterm1_id}-
                                      {submitDesc[_index]?.incoterm2_id}
                                    </span>
                                  </td>
                                )}
                              </>
                            )}
                            <td className='td-order-3 text-center column'>
                              <span className='d-block py-3' style={{margin: '-.5px 0'}}>
                                <PopoverText
                                  content={
                                    submitDesc[_index]?.province_id +
                                    (submitDesc[_index]?.city_id
                                      ? ', ' + submitDesc[_index]?.city_id
                                      : submitDesc[_index]?.city_id)
                                  }
                                  index={_index}
                                  className='spec-sliceee'
                                />
                              </span>
                            </td>
                            {item.sector_id == 1 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block py-3'>
                                  {t(submitDesc[_index]?.segment_name)}
                                </span>
                              </td>
                            )}
                            <td className='td-order-3 text-center column'>
                              <span className='d-block py-3'>
                                <PopoverText
                                  content={
                                    submitDesc[_index]?.no_enduser
                                      ? submitDesc[_index]?.end_user
                                      : handleShowValue(submitDesc[_index]?.end_user)
                                  }
                                  index={_index}
                                  className='desc-slice'
                                />
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block py-3'>
                                {t(submitDesc[_index]?.sector_id)}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block py-3'>
                                {submitDesc[_index]?.product_type}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block py-3'>
                                {parseInt(item.material_number) == 0
                                  ? ''
                                  : item.material_number.slice(-7)}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block py-3'>
                                <PopoverText
                                  content={item.product_name}
                                  index={_index}
                                  className='spec-slicee'
                                />
                              </span>
                            </td>
                            {item.product_spec ? (
                              <td className='td-order-3 text-center column'>
                                <span className='d-block py-3'>
                                  <PopoverText
                                    content={item?.product_spec}
                                    index={_index}
                                    className='spec-slicee'
                                  />
                                </span>
                              </td>
                            ) : (
                              <td className='td-order-3 text-center column text-light'>
                                <span className='d-block py-3'>-</span>
                              </td>
                            )}
                            <td className='td-order-2 text-center column'>
                              <span className='d-block py-3'>
                                {i18next.language === 'en'
                                  ? item.request_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : item.request_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {item.sector_id === 3 ? 'MT' : 'Ton'}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block py-3'>
                                {item.is_formulated_price == true ? (
                                  <>
                                    <p>{t('Formulated Price')}</p>
                                  </>
                                ) : (
                                  <>
                                    {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                      (i18next.language === 'en'
                                        ? item.request_price?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.request_price?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })) +
                                      (item.sector_id != 3 ? '/Ton' : '/MT')}
                                  </>
                                )}
                              </span>
                            </td>
                            {submitOrder[0]?.sector_id == 1 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block py-3'>
                                  {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                </span>
                              </td>
                            )}
                            {submitOrder[0]?.sector_id != null ||
                            submitOrder[0]?.sector_id != undefined ? (
                              <>
                                {isRetail(submitOrder[0]?.sector_id) ? (
                                  <td className='td-order-3 text-center column'>
                                    <span className='d-block py-3'>
                                      <PopoverText
                                        content={item.plant + " - " + item.plant_desc}
                                        index={_index}
                                        className='spec-slice'
                                      />
                                    </span>
                                  </td>
                                ) : (
                                  ''
                                )}
                              </>
                            ) : (
                              ''
                            )}
                            {item.notes ? (
                              <td className='td-order-2 text-center column py-3'>
                                <span className='d-block py-3'>
                                  <PopoverText
                                    content={item.notes}
                                    index={_index}
                                    className='spec-slicee'
                                  />
                                </span>
                              </td>
                            ) : (
                              <td className='td-order-2 text-center column text-light'>
                                <span className='d-block py-3'>-</span>
                              </td>
                            )}
                            {/* <td className='td-order-2 text-center column'>Status</td> */}
                          </tr>
                        </tbody>
                      ))}
                    </>
                  ) : (
                    <>
                      {nonPenjualanFlag == 'form1' ? (
                        <>
                          {submitOrder.map((item, _index) => (
                            <tbody key={item?.id ?? _index}>
                              <tr className='d-flex jusify-content-center w-100 align-items-center'>
                                <td className='td-order-4 text-center column'>
                                  <div className='d-flex justify-content-center'>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title='Detail'
                                      onClick={() => {
                                        setShowDetail(true)
                                        setTempKontrakID(item.sector_id)
                                        setTest(submitDesc[_index])
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/file-text-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                    {!isSubmit ? (
                                      <>
                                        <button
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('ubah')}
                                          onClick={() => {
                                            setState(item, _index)
                                            setTempID(_index)
                                            setTempKontrakID(item.sector_id)
                                            setTest(submitDesc[_index])
                                          }}
                                        >
                                          <KTSVG
                                            // pencil
                                            path='/media/icons/duotune/pencil-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>

                                        <button
                                          onClick={() => {
                                            setIsFileBox(true)
                                            formattingTon(item.request_quantum)
                                            setSektor(item.sector_id)
                                            setProvinceDesc(submitDesc[_index]?.province_id)
                                            setCityDesc(submitDesc[_index]?.city_id)
                                            setPname(item.product_name)
                                            setIndex2(_index)
                                            removeFileState()
                                            handleUploadOrderItem(item)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('order-lampiran')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/archive-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                    {!isSubmit ? (
                                      <>
                                        <button
                                          onClick={() =>
                                            handleDeleteItems(
                                              _index,
                                              submitOrder,
                                              setSubmitOrder,
                                              submitDesc,
                                              setSubmitDesc
                                            )
                                          }
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('Hapus')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/trash-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </td>
                                <td className='td-order-1 text-center column'>
                                  <span className='d-block py-3'>{_index + 1}</span>
                                </td>
                                <td className='td-order-4 text-center column'>
                                  <span className='d-block py-3'>
                                    {submitDesc[_index]?.sales_org_code}
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {submitDesc[_index]?.incoterm1_id}
                                  </span>
                                </td>
                                {item.sector_id != 3 ? (
                                  <td className='td-order-3 text-center column'>
                                    <span className='d-block py-3'>
                                      <PopoverText
                                        content={
                                          submitDesc[_index]?.province_id +
                                          ', ' +
                                          submitDesc[_index]?.city_id
                                        }
                                        index={_index}
                                        className='spec-slice'
                                      />
                                    </span>
                                  </td>
                                ) : (
                                  ''
                                )}
                                <td className='td-order-3 text-center column'>
                                  <span className='d-block py-3'>
                                    <PopoverText
                                      content={
                                        submitDesc[_index]?.no_enduser
                                          ? submitDesc[_index]?.end_user
                                          : handleShowValue(submitDesc[_index]?.end_user)
                                      }
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {t(submitDesc[_index]?.sector_id)}
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {submitDesc[_index]?.product_type}
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {parseInt(item.material_number) == 0
                                      ? ''
                                      : item.material_number.slice(-7)}
                                  </span>
                                </td>
                                <td className='td-order-4 text-center column'>
                                  <span className='d-block py-3'>
                                    <PopoverText
                                      content={item.product_name}
                                      index={_index}
                                      className='spec-slicee'
                                    />
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {i18next.language === 'en'
                                      ? item.request_quantum?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : item.request_quantum?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}{' '}
                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                      (i18next.language === 'en'
                                        ? item.request_price?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item.request_price?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })) +
                                      (item.sector_id != 3 ? '/Ton' : '/MT')}
                                  </span>
                                </td>
                                {submitOrder[0]?.sector_id == 1 && (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block py-3'>
                                      {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                    </span>
                                  </td>
                                )}
                                {item.notes ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block py-3'>
                                      <PopoverText
                                        content={item.notes}
                                        index={_index}
                                        className='spec-slicee'
                                      />
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column text-light py-3'>
                                    <span className='d-block py-3'>-</span>
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          ))}
                        </>
                      ) : (
                        <>
                          {submitOrder.map((item, _index) => (
                            <tbody key={item?.id ?? _index}>
                              <tr className='d-flex jusify-content-center w-100 align-items-center'>
                                <td className='td-order-4 text-center column'>
                                  <div className='d-flex justify-content-center'>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title='Detail'
                                      onClick={() => {
                                        setShowDetail(true)
                                        setTempKontrakID(item.sector_id)
                                        setTest(submitDesc[_index])
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/file-text-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                    {!isSubmit ? (
                                      <>
                                        <button
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('ubah')}
                                          onClick={() => {
                                            setState(item, _index)
                                            setTempID(_index)
                                            setTempKontrakID(item.sector_id)
                                            setTest(submitDesc[_index])
                                          }}
                                        >
                                          <KTSVG
                                            // pencil
                                            path='/media/icons/duotune/pencil-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>

                                        <button
                                          onClick={() => {
                                            setIsFileBox(true)
                                            formattingTon(item.request_quantum)
                                            setSektor(item.sector_id)
                                            setProvinceDesc(submitDesc[_index]?.province_id)
                                            setCityDesc(submitDesc[_index]?.city_id)
                                            setPname(item.product_name)
                                            setIndex2(_index)
                                            removeFileState()
                                            handleUploadOrderItem(item)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('order-lampiran')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/archive-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                    {!isSubmit ? (
                                      <>
                                        <button
                                          onClick={() =>
                                            handleDeleteItems(
                                              _index,
                                              submitOrder,
                                              setSubmitOrder,
                                              submitDesc,
                                              setSubmitDesc
                                            )
                                          }
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('Hapus')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/trash-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </td>
                                <td className='td-order-1 text-center column'>
                                  <span className='d-block py-3'>{_index + 1}</span>
                                </td>
                                <td className='td-order-4 text-center column'>
                                  <span className='d-block py-3'>
                                    {submitDesc[_index]?.sales_org_code}
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {t(submitDesc[_index]?.sector_id)}
                                  </span>
                                </td>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block py-3'>
                                    {submitDesc[_index]?.product_type}
                                  </span>
                                </td>
                                <td className='td-order-4 text-center column'>
                                  <span className='d-block py-3'>
                                    <PopoverText
                                      content={item.product_name}
                                      index={_index}
                                      className='spec-slicee'
                                    />
                                  </span>
                                </td>
                                {item.notes ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block py-3'>
                                      <PopoverText
                                        content={item.notes}
                                        index={_index}
                                        className='spec-slicee'
                                      />
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column text-light'>
                                    <span className='d-block py-3'>-</span>
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          ))}
                        </>
                      )}
                    </>
                  )}

                  { submitOrder.length == 0 && (
                    <tbody>
                      <tr>
                        <td colSpan={14} className='text-center p-4 bg-secondary'>{ t('tambah-produk') }</td>
                      </tr>
                    </tbody>
                  ) } 
                </table>
                {/* End Table Head */}
              </div>
            )}

            {isUpload ? (
              <></>
            ) : (
              <div className='d-flex justify-content-end mt-5'>
                <Link to='/management/order/all' className='me-2 btn btn-secondary'>
                  <i className='fa fa-chevron-left'></i>
                  { isSubmit ? t('order-kembali') : t('cancel') }
                </Link>
                {!isSubmit ? (
                  <Button
                    hidden={regarding == 'PO003' ? true : false}
                    variant='primary'
                    type='submit'
                    disabled={!enableSendOrder}
                    onClick={() => setShowApprove(true)}
                  >
                    <i className='fa fa-paper-plane'></i>
                    {handleLoading(false)}
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            )}
          </div>

          <Modal show={showApprove} onHide={() => setShowApprove(false)} centered backdrop='static'>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <h3 className='text-center mb-5'>{t('apakahAndaYakin create order')}</h3>
            </Modal.Body>
            <Modal.Footer>
              <Button className='btn btn-secondary' onClick={() => setShowApprove(false)}>
                {t('Tidak')}
              </Button>
              <Button className='btn btn-primary' onClick={postOrder} disabled={btnLoading}>
                {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={show3}
            onHide={() => {
              setShow3(false)
              sessionStorage.removeItem('isCustomer')
            }}
            centered
            size='xl'
            backdrop='static'
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
                {pname} | {fixedQuantum} Ton
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <span style={{fontSize: '15px'}} className='fw-bold d-block fs-6'>
                {t('Jadwal')}
              </span>
              <AddRemoveJadwal id={SubID} is_amendment={'false'} />
            </Modal.Body>
          </Modal>

          <Modal
            show={showDetail}
            onHide={() => setShowDetail(false)}
            backdrop='static'
            keyboard={false}
            detail
            centered
            scrollable={showPurchaseForm ? true : false}
            size='xl'
          >
            <Modal.Header closeButton>
              <Modal.Title>Detail {t('Order')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {showPurchaseForm ? (
                <>
                  {tempKontrakID == '3' && (
                    <>
                      <Row>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('kontrak-produsen')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.sales_org_code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.incoterm1_id}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                size='sm'
                                value={test?.province_id}
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_type}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseFloat(test?.request_quantum).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' MT'
                                    : parseFloat(test?.request_quantum).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' MT'
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-3'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('Shipping Tolerance')} </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                size='sm'
                                type='text'
                                id='shipping'
                                // placeholder={t('Shipping Tolerance')}
                                value={
                                  test?.shipping_tolerance == 0
                                    ? ''
                                    : test?.shipping_tolerance + '%'
                                }
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.payment_type_1}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                defaultValue={test?.payment_note}
                                id='keterangan'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  test.no_enduser ? test.end_user : handleShowValue(test.end_user)
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(test.sector_id)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  test.incoterm2_id == '0' || test.incoterm2_id == null
                                    ? ''
                                    : test.incoterm2_id
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control type='text' size='sm' value={test?.city_id} disabled />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_name}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-2'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('Harga Pengajuan') + '/MT'}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'USD' + i18next.language === 'en'
                                    ? parseFloat(test?.request_price).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : parseFloat(test?.request_price).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className=' fs-6'>{t('Formulated Price')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start align-items-center'>
                              <Form.Check
                                reverse
                                name='formula_Price'
                                className='mt-5 mb-2'
                                type='checkbox'
                                checked={test.is_formulated_price}
                                id='formula_Price'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.payment_type_2}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_spec}
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.notes}
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                disabled
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}

                  {tempKontrakID == '1' && (
                    <>
                      <Row>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('kontrak-produsen')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.sales_org_code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.incoterm1_id}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                size='sm'
                                value={test?.province_id}
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_type}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseFloat(test?.request_quantum).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                    : parseFloat(test?.request_quantum).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('Shipping Tolerance')} </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                size='sm'
                                type='text'
                                id='shipping'
                                // placeholder={t('Shipping Tolerance')}
                                value={
                                  test?.shipping_tolerance == 0
                                    ? ''
                                    : test?.shipping_tolerance + '%'
                                }
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.payment_type_1}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                defaultValue={test?.payment_note}
                                id='keterangan'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('segment')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                type='text'
                                defaultValue={t(test.segment_name)}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  test.no_enduser ? test.end_user : handleShowValue(test.end_user)
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(test.sector_id)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  test.incoterm2_id == '0' || test.incoterm2_id == null
                                    ? ''
                                    : test.incoterm2_id
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control type='text' size='sm' value={test?.city_id} disabled />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_name}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('Harga Pengajuan') + '/Ton'}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'Rp' + i18next.language === 'en'
                                    ? parseFloat(test?.request_price).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : parseFloat(test?.request_price).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>

                          <Row className='my-7'>
                            <Col sm={6} className='d-flex '>
                              <Row sm={8} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('termasuk-ppn')}</p>
                              </Row>
                              <Row
                                sm={4}
                                className='d-flex justify-content-start align-items-center ms-4'
                              >
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className=''
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  checked={test.include_ppn}
                                />
                              </Row>
                            </Col>
                            <Col sm={6} className='d-flex'>
                              <Row sm={8} className='d-flex align-items-center'>
                                <p className=' fs-6'>{t('Formulated Price')}</p>
                              </Row>
                              <Row
                                sm={4}
                                className='d-flex justify-content-start align-items-center ms-4'
                              >
                                <Form.Check
                                  reverse
                                  name='formula_Price'
                                  className=''
                                  type='checkbox'
                                  checked={test.is_formulated_price}
                                  id='formula_Price'
                                />
                              </Row>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.payment_type_2}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_spec}
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.notes}
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                disabled
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}

                  {isRetail(tempKontrakID) && (
                    <>
                      <Row>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('kontrak-produsen')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.sales_org_code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.incoterm1_id}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('destination-city')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control type='text' size='sm' value={test?.city_id} disabled />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_type}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_name}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>

                          {/* <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('destination-province')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control type='text' size='sm' value={test?.province_dest_id} disabled />
                            </Col>
                          </Row> */}

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseFloat(test?.request_quantum).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                    : parseFloat(test?.request_quantum).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.payment_type_1}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('so-namaAngkut')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.moda_angkut_name}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          
                          <Row className='mb-4'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                defaultValue={test?.payment_note}
                                id='keterangan'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('commodity')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('commodity')}
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                                defaultValue={test?.commodity}
                                disabled
                              />
                            </Col>
                        </Row>
                        </Col>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(test.sector_id)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {isRetail(tempKontrakID) ? (
                                <>
                                  {test.incoterm2_id == '0' ||
                                  test.incoterm2_id == '' ||
                                  test?.incoterm2_id == undefined ? (
                                    <Form.Control
                                      value={test.city_plant}
                                      type='text'
                                      size='sm'
                                      disabled
                                    />
                                  ) : (
                                    <Form.Control
                                      value={test.incoterm2_id}
                                      type='text'
                                      size='sm'
                                      disabled
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  {test.incoterm2_id == '0' ||
                                  test.incoterm2_id == '' ||
                                  test.incoterm2_id == null ||
                                  test?.incoterm2_id == undefined ? (
                                    <Form.Control type='text' size='sm' disabled />
                                  ) : (
                                    <Form.Control
                                      value={test.incoterm2_id}
                                      type='text'
                                      size='sm'
                                      disabled
                                    />
                                  )}
                                </>
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('destination-province')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                size='sm'
                                value={test?.province_id}
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('pickup-plant')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.plant + " - " + test.plant_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>

                          {/* <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('destination-city')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control type='text' size='sm' value={test?.city_dest_id} disabled />
                            </Col>
                          </Row> */}
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test.product_spec}
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'Rp' + i18next.language === 'en'
                                    ? parseFloat(test?.request_price).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : parseFloat(test?.request_price).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })
                                }
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4' hidden={!isAdmin ? true : false}>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.payment_type_2}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('so-jenisAngkut')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                size='sm'
                                defaultValue={i18next.language == 'en' ? test?.moda_angkut_type_en : test?.moda_angkut_type}
                                id='so-jenisAngkut'
                                disabled
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={test?.notes}
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                disabled
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              ) : (
                <>
                  {nonPenjualanFlag == 'form1' ? (
                    <>
                      <Row>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                value={test.sales_org_code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>Incoterm</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                value={test?.incoterm1_id}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          {tempKontrakID != '3' ? (
                            <>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    type='text'
                                    size='sm'
                                    value={test?.province_id}
                                    disabled
                                  />
                                </Col>
                              </Row>
                            </>
                          ) : (
                            ''
                          )}
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                value={test.product_type}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col sm={8}>
                              <InputGroup size='sm'>
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(test?.request_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                      : parseFloat(test?.request_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' Ton'
                                  }
                                  type='text'
                                  size='sm'
                                  disabled
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('End Customer')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                value={
                                  test.no_enduser ? test.end_user : handleShowValue(test.end_user)
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                value={t(test.sector_id)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                value={test?.notes}
                                as='textarea'
                                size='sm'
                                style={{height: '40px'}}
                                disabled
                              />
                            </Col>
                          </Row>

                          {tempKontrakID != '3' ? (
                            <>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    type='text'
                                    size='sm'
                                    value={test?.city_id}
                                    disabled
                                  />
                                </Col>
                              </Row>
                            </>
                          ) : (
                            ''
                          )}
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                value={test.product_name}
                                type='text'
                                size='sm'
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                            </Col>
                            <Col sm={8}>
                              {tempKontrakID != '3' ? (
                                <Form.Control
                                  value={
                                    'Rp' + i18next.language === 'en'
                                      ? parseFloat(test?.request_price).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseFloat(test?.request_price).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })
                                  }
                                  type='text'
                                  size='sm'
                                  disabled
                                />
                              ) : (
                                <Form.Control
                                  value={
                                    'USD' + i18next.language === 'en'
                                      ? parseFloat(test?.request_price).toLocaleString('en', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                      : parseFloat(test?.request_price).toLocaleString('id', {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                  }
                                  type='text'
                                  size='sm'
                                  disabled
                                />
                              )}
                            </Col>
                          </Row>
                          {tempKontrakID != '3' ? (
                            <>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>{t('termasuk-ppn')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    className='mt-3 mb-2'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={test.include_ppn}
                                  />
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <></>
                          )}
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row className='mb-3'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={test.sales_org_code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control value={t(test.sector_id)} type='text' disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control value={test.product_type} type='text' size='sm' disabled />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control value={test.product_name} type='text' size='sm' disabled />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={test?.notes}
                            as='textarea'
                            size='sm'
                            style={{height: '40px'}}
                            disabled
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('End Customer')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={test.no_enduser ? test.end_user : handleShowValue(test.end_user)}
                            as='textarea'
                            style={{height: '40px'}}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            show={showEdit}
            onHide={() => setShowEdit(false)}
            backdrop='static'
            keyboard={false}
            centered
            scrollable={showPurchaseForm ? true : false}
            size='xl'
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {t('Edit')} {t('Order')}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {loading ? (
                <div className='d-flex justify-content-center'>
                  <Spinner animation='border' variant='primary' />
                </div>
              ) : (
                <>
                  {showPurchaseForm ? (
                    <>
                      {idSektor == 3 && (
                        <>
                          <Row>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('kontrak-produsen')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produsen'
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      salesArea[
                                        salesArea.findIndex(
                                          (item: any) => item.label === produsenDesc
                                        )
                                      ]
                                    }
                                    isDisabled
                                    onChange={(e: any) => {
                                      separateValue3(
                                        setProdusen,
                                        e?.value,
                                        setDistribution,
                                        setProdusenDesc
                                      )
                                      fieldClearer(8)
                                    }}
                                    options={salesArea}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-incoterm1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm1'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullIncoterm[
                                        fullIncoterm.findIndex(
                                          (item: any) => item.label === incoterm1Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                    }}
                                    options={fullIncoterm}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-provinsi')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='provinsi'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullProvince[
                                        fullProvince.findIndex(
                                          (item: any) => item.label === provinceDesc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      setFullCity([])
                                      cityData(e?.value)
                                    }}
                                    options={fullProvince}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-jenis')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='jenis'
                                    onChange={(e: any) => productTypeChange(e.target.value)}
                                  >
                                    {/* <option selected hidden disabled>{t(test?.product_type)}</option> */}
                                    <option hidden value='~#~'>
                                      {t('Pilih-productType')}
                                    </option>
                                    {fullProductType.map((item: any) => {
                                      return (
                                        <>
                                          {item.id != 12 && (
                                            <>
                                              {item.material_group_desc == test?.product_type ? (
                                                <option
                                                  selected
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              ) : (
                                                <option
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              {parseInt(pnumber) == 0 && (
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6'>
                                      Custom Product Name<span className='text-danger'>*</span>
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      placeholder=' Custom Product Name'
                                      defaultValue={test?.product_name}
                                      size='sm'
                                      aria-label='Default select example'
                                      type='text'
                                      id='custom'
                                      onChange={(e: any) => setPname(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('Kuantum Pengajuan')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='kuantum'
                                      // key={pname}
                                      placeholder={t('Kuantum Pengajuan')}
                                      defaultValue={quantum}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setQuantum(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={2}
                                    />
                                    <InputGroup.Text id='basic-addon2'>MT</InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup>
                                    <Form.Control
                                      placeholder={t('Shipping Tolerance')}
                                      size='sm'
                                      type='number'
                                      id='shipping'
                                      defaultValue={shipping}
                                      onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                    />
                                    <InputGroup.Text
                                      id='basic-addon2'
                                      style={{paddingTop: '1px', paddingBottom: '1px'}}
                                    >
                                      <span className='px-1'>%</span>
                                    </InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-payment1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='payment1'
                                    onChange={(e: any) =>
                                      separateValue(setPay1, e.target.value, setPay1Desc)
                                    }
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-payment')}
                                    </option>
                                    {fullPayment.map((item: any) => {
                                      return (
                                        <>
                                          {item.payment_desc == test?.payment_type_1 ? (
                                            <option
                                              selected
                                              value={item.code + '~#~' + item.payment_desc}
                                            >
                                              {item.payment_desc}
                                            </option>
                                          ) : (
                                            <option value={item.code + '~#~' + item.payment_desc}>
                                              {item.payment_desc}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.payment_note}
                                    placeholder={t('keterangan')}
                                    id='keterangan'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setketerangan(e.target.value)}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('End Customer')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    size='sm'
                                    as='textarea'
                                    id='enduser'
                                    style={{height: '40px'}}
                                    placeholder={t('End Customer')}
                                    // defaultValue={test?.no_enduser ? test?.end_user : ''}
                                    defaultValue={test?.end_user}
                                    onChange={(e: any) => {
                                      setEnduser(e.target.value)
                                      setEnduserDesc(e.target.value)
                                    }}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {localStorage.getItem('cust-group') != 'AR06' ? (
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='sektor'
                                      disabled
                                      onChange={(e: any) => {
                                        setSektor(e.target.value)
                                        getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                        fieldClearer(7)
                                      }}
                                    >
                                      <option hidden value={0 + ';;'}>
                                        {t('Pilih-sector')}
                                        <span className='text-danger'>*</span>
                                      </option>
                                      {fullSector.map((item: any) => {
                                        return (
                                          <>
                                            {item.name == test?.sector_id ? (
                                              <option
                                                selected
                                                value={item.id + '~#~' + '' + '~#~' + item.name}
                                              >
                                                {t(item.name)}
                                              </option>
                                            ) : (
                                              <option value={item.id + '~#~' + '' + '~#~' + item.name}>
                                                {t(item.name)}
                                              </option>
                                            )}
                                          </>
                                        )
                                      })}
                                    </Form.Select>
                                  ) : (
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='sektor2'
                                      disabled
                                    >
                                      <option selected>Export</option>
                                    </Form.Select>
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm2'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullIncoterm2[
                                        fullIncoterm2.findIndex(
                                          (item: any) => item.label === incoterm2Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                                    }}
                                    options={fullIncoterm2}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-kota')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='kota'
                                    key={province}
                                    isDisabled
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullCity[
                                        fullCity.findIndex((item: any) => item.label === cityDesc)
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setCity, e?.value, setCityDesc)
                                      // fieldClearer(4)
                                    }}
                                    options={fullCity}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3'>
                                    {t('sub-order-produk')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produk'
                                    key={ptype}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullProductName[
                                        fullProductName.findIndex(
                                          (item: any) => item.truevalue == parseInt(pnumber)
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      productNameChange(e?.value)
                                      // fieldClearer(1)
                                    }}
                                    options={fullProductName}
                                  />
                                </Col>
                              </Row>
                              {parseInt(pnumber) == 0 && (
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      defaultValue={test?.notes}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setNote(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}

                              <Row className='mb-2'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>
                                    {t('Harga Pengajuan')}/MT
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <InputGroup.Text id='basic-addon2'>
                                      <span className='px-2'>USD</span>
                                    </InputGroup.Text>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='hargap'
                                      key={test.is_formulated_price}
                                      defaultValue={test.is_formulated_price ? '' : subprice}
                                      disabled={test.is_formulated_price}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setSubprice(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={2}
                                      placeholder={t('Harga Pengajuan')}
                                    />
                                  </InputGroup>
                                </Col>
                              </Row>

                              <Row className='mb-2'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className=' fs-6'>{t('Formulated Price')}</p>
                                </Col>
                                <Col
                                  sm={8}
                                  className='d-flex justify-content-start align-items-center'
                                >
                                  <Form.Check
                                    reverse
                                    name='formula_Price'
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                    value={test.is_formulated_price}
                                    onClick={() => {
                                      setTest((prev: any) => ({
                                        ...prev,
                                        is_formulated_price: !prev.is_formulated_price,
                                      }))
                                      setFormulaPrice(!test.is_formulated_price)
                                    }}
                                    defaultChecked={test.is_formulated_price}
                                    id='formula_Price'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='payment2'
                                    onChange={(e: any) =>
                                      separateValue(setPay2, e.target.value, setPay2Desc)
                                    }
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-payment')}
                                    </option>
                                    {fullPayment.map((item: any) => {
                                      return (
                                        <>
                                          {item.payment_desc == test?.payment_type_2 ? (
                                            <option
                                              selected
                                              value={item.code + '~#~' + item.payment_desc}
                                            >
                                              {item.payment_desc}
                                            </option>
                                          ) : (
                                            <option value={item.code + '~#~' + item.payment_desc}>
                                              {item.payment_desc}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder={t('sub-order-spek')}
                                    as='textarea'
                                    defaultValue={test?.product_spec}
                                    id='spek'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setPspec(e.target.value)}
                                  />
                                </Col>
                              </Row>
                              {parseInt(pnumber) != 0 && (
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      defaultValue={test?.notes}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setNote(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}

                      {idSektor == 1 && (
                        <>
                          <Row>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('kontrak-produsen')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produsen'
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      salesArea[
                                        salesArea.findIndex(
                                          (item: any) => item.label === produsenDesc
                                        )
                                      ]
                                    }
                                    isDisabled
                                    onChange={(e: any) => {
                                      separateValue3(
                                        setProdusen,
                                        e?.value,
                                        setDistribution,
                                        setProdusenDesc
                                      )
                                      fieldClearer(8)
                                    }}
                                    options={salesArea}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-incoterm1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm1'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullIncoterm[
                                        fullIncoterm.findIndex(
                                          (item: any) => item.label === incoterm1Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                    }}
                                    options={fullIncoterm}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-provinsi')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='provinsi'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullProvince[
                                        fullProvince.findIndex(
                                          (item: any) => item.label === provinceDesc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      setFullCity([])
                                      cityData(e?.value)
                                    }}
                                    options={fullProvince}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-jenis')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='jenis'
                                    onChange={(e: any) => productTypeChange(e.target.value)}
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-productType')}
                                    </option>
                                    {fullProductType.map((item: any) => {
                                      return (
                                        <>
                                          {item.id != 12 && (
                                            <>
                                              {item.material_group_desc == test?.product_type ? (
                                                <option
                                                  selected
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              ) : (
                                                <option
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              {parseInt(pnumber) == 0 && (
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6'>
                                      Custom Product Name<span className='text-danger'>*</span>
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      placeholder=' Custom Product Name'
                                      defaultValue={test?.product_name}
                                      size='sm'
                                      aria-label='Default select example'
                                      type='text'
                                      id='custom'
                                      onChange={(e: any) => setPname(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('Kuantum Pengajuan')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='kuantum'
                                      // key={pname}
                                      placeholder={t('Kuantum Pengajuan')}
                                      defaultValue={quantum}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setQuantum(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={2}
                                    />
                                    <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup>
                                    <Form.Control
                                      placeholder={t('Shipping Tolerance')}
                                      size='sm'
                                      type='number'
                                      id='shipping'
                                      defaultValue={shipping}
                                      onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                    />
                                    <InputGroup.Text
                                      id='basic-addon2'
                                      style={{paddingTop: '1px', paddingBottom: '1px'}}
                                    >
                                      <span className='px-1'>%</span>
                                    </InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-payment1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='payment1'
                                    onChange={(e: any) =>
                                      separateValue(setPay1, e.target.value, setPay1Desc)
                                    }
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-payment')}
                                    </option>
                                    {fullPayment.map((item: any) => {
                                      return (
                                        <>
                                          {item.payment_desc_id == test?.payment_type_1 ? (
                                            <option
                                              selected
                                              value={item.code + '~#~' + item.payment_desc_id}
                                            >
                                              {item.payment_desc_id}
                                            </option>
                                          ) : (
                                            <option value={item.code + '~#~' + item.payment_desc_id}>
                                              {item.payment_desc_id}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.payment_note}
                                    placeholder={t('keterangan')}
                                    id='keterangan'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setketerangan(e.target.value)}
                                  />
                                </Col>
                              </Row>
                              {parseInt(pnumber) != 0 && (
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>
                                      {t('segment')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Select
                                      id='segment'
                                      onChange={(e: any) =>
                                        separateValue(setSegment, e.target.value, setSegmentDesc)
                                      }
                                      aria-label='Default select example'
                                      size='sm'
                                    >
                                      {fullSegment.map((item: any) => {
                                        if (item.code == 'Z2' || item.code == 'Z3') {
                                          if (item.code == segment) {
                                            return (
                                              <option selected value={item.code + '~#~' + item.name}>
                                                {item.name}
                                              </option>
                                            )
                                          } else {
                                            return (
                                              <option value={item.code + '~#~' + item.name}>
                                                {item.name}
                                              </option>
                                            )
                                          }
                                        } else {
                                          return null
                                        }
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>
                              )}
                              <Row className='mb-1'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('End Customer')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {isNoEnduser ? (
                                    <Form.Control
                                      size='sm'
                                      as='textarea'
                                      id='enduser'
                                      style={{height: '40px'}}
                                      placeholder={t('End Customer')}
                                      defaultValue={test?.no_enduser ? test?.end_user : ''}
                                      onChange={(e: any) => {
                                        setEnduser(e.target.value)
                                        setEnduserDesc(e.target.value)
                                      }}
                                    />
                                  ) : (
                                    <MultiSelect
                                      options={fullEndUser?.map((item: any) => {
                                        return {label: item.name, value: item.name}
                                      })}
                                      value={arrayEnduser}
                                      onChange={(e: any) => setEnduserArray(e)}
                                      labelledBy='Select'
                                    />
                                  )}
                                </Col>
                              </Row>
                              {idSektor == 1 && (
                                <Row className='mb-4'>
                                  <Col sm={4}></Col>
                                  <Col sm={8} className='d-flex align-items-center'>
                                    <Form.Check
                                      onClick={() => {
                                        setIsNoEnduser(!isNoEnduser)
                                      }}
                                      defaultChecked={isNoEnduser}
                                      name='noenduser'
                                      // disabled={ptype == 'P13'}
                                      id='noenduser'
                                      className='mt-5 mb-2'
                                      type='checkbox'
                                    />
                                    {i18next.language == 'en' ? (
                                      <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                    ) : (
                                      <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                    )}
                                  </Col>
                                </Row>
                              )}
                            </Col>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {localStorage.getItem('cust-group') != 'AR06' ? (
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='sektor'
                                      disabled
                                      onChange={(e: any) => {
                                        setSektor(e.target.value)
                                        getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                        fieldClearer(7)
                                      }}
                                    >
                                      <option hidden value={0 + ';;'}>
                                        {t('Pilih-sector')}
                                        <span className='text-danger'>*</span>
                                      </option>
                                      {fullSector.map((item: any) => {
                                        return (
                                          <>
                                            {item.name == test?.sector_id ? (
                                              <option
                                                selected
                                                value={item.id + '~#~' + '' + '~#~' + item.name}
                                              >
                                                {t(item.name)}
                                              </option>
                                            ) : (
                                              <option value={item.id + '~#~' + '' + '~#~' + item.name}>
                                                {t(item.name)}
                                              </option>
                                            )}
                                          </>
                                        )
                                      })}
                                    </Form.Select>
                                  ) : (
                                    <Form.Select
                                      aria-label='Default select example'
                                      id='sektor2'
                                      disabled
                                    >
                                      <option selected>Export</option>
                                    </Form.Select>
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm2'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullIncoterm2[
                                        fullIncoterm2.findIndex(
                                          (item: any) => item.label === incoterm2Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                                    }}
                                    options={fullIncoterm2}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-kota')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='kota'
                                    key={province}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullCity[
                                        fullCity.findIndex((item: any) => item.label === cityDesc)
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setCity, e?.value, setCityDesc)
                                      // fieldClearer(4)
                                    }}
                                    options={fullCity}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3'>
                                    {t('sub-order-produk')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produk'
                                    key={ptype}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullProductName[
                                        fullProductName.findIndex(
                                          (item: any) => item.truevalue == parseInt(pnumber)
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      // setQuantum(0)
                                      // setSubprice(0)
                                      productNameChange(e?.value)
                                      // fieldClearer(1)
                                    }}
                                    options={fullProductName}
                                  />
                                </Col>
                              </Row>
                              {parseInt(pnumber) == 0 && (
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      defaultValue={test?.notes}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setNote(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>
                                    {t('Harga Pengajuan')}/Ton
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <InputGroup.Text id='basic-addon2'>
                                      <span className='px-1'>Rp</span>
                                    </InputGroup.Text>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='hargap'
                                      key={test.is_formulated_price}
                                      defaultValue={test.is_formulated_price ? '0' : subprice}
                                      disabled={test.is_formulated_price}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setSubprice(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={-1}
                                      placeholder={t('Harga Pengajuan')}
                                    />
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='my-7'>
                                <Col sm={6} className='d-flex '>
                                  <Row sm={8} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('termasuk-ppn')}</p>
                                  </Row>
                                  <Row
                                    sm={4}
                                    className='d-flex justify-content-start align-items-center ms-4'
                                  >
                                    <Form.Check
                                      reverse
                                      name='ppn'
                                      type='checkbox'
                                      id='ckbox-ppn'
                                      defaultChecked={test.include_ppn}
                                    />
                                  </Row>
                                </Col>
                                <Col sm={6} className='d-flex'>
                                  <Row sm={8} className='d-flex align-items-center'>
                                    <p className=' fs-6'>{t('Formulated Price')}</p>
                                  </Row>
                                  <Row
                                    sm={4}
                                    className='d-flex justify-content-start align-items-center ms-4'
                                  >
                                    <Form.Check
                                      reverse
                                      name='formula_Price'
                                      type='checkbox'
                                      value={test.is_formulated_price}
                                      onClick={() => {
                                        setTest((prev: any) => ({
                                          ...prev,
                                          is_formulated_price: !prev.is_formulated_price,
                                        }))
                                        setFormulaPrice(!test.is_formulated_price)
                                      }}
                                      defaultChecked={test.is_formulated_price}
                                      id='formula_Price'
                                    />
                                  </Row>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='payment2'
                                    onChange={(e: any) =>
                                      separateValue(setPay2, e.target.value, setPay2Desc)
                                    }
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-payment')}
                                    </option>
                                    {fullPayment.map((item: any) => {
                                      return (
                                        <>
                                          {item.payment_desc_id == test?.payment_type_2 ? (
                                            <option
                                              selected
                                              value={item.code + '~#~' + item.payment_desc_id}
                                            >
                                              {item.payment_desc_id}
                                            </option>
                                          ) : (
                                            <option value={item.code + '~#~' + item.payment_desc_id}>
                                              {item.payment_desc_id}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder={t('sub-order-spek')}
                                    as='textarea'
                                    defaultValue={test?.product_spec}
                                    id='spek'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setPspec(e.target.value)}
                                  />
                                </Col>
                              </Row>
                              {parseInt(pnumber) != 0 && (
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      defaultValue={test?.notes}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setNote(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                              {parseInt(pnumber) == 0 && (
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>
                                      {t('segment')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Select
                                      id='segment'
                                      onChange={(e: any) =>
                                        separateValue(setSegment, e.target.value, setSegmentDesc)
                                      }
                                      aria-label='Default select example'
                                      size='sm'
                                    >
                                      {fullSegment.map((item: any) => {
                                        if (item.code == 'Z2' || item.code == 'Z3') {
                                          if (item.code == segment) {
                                            return (
                                              <option selected value={item.code + '~#~' + item.name}>
                                                {item.name}
                                              </option>
                                            )
                                          } else {
                                            return (
                                              <option value={item.code + '~#~' + item.name}>
                                                {item.name}
                                              </option>
                                            )
                                          }
                                        } else {
                                          return null
                                        }
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}

                      {isRetail(idSektor) && (
                        <>
                          <Row>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('kontrak-produsen')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produsen'
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      salesArea[
                                        salesArea.findIndex(
                                          (item: any) => item.label === produsenDesc
                                        )
                                      ]
                                    }
                                    isDisabled
                                    onChange={(e: any) => {
                                      separateValue3(
                                        setProdusen,
                                        e?.value,
                                        setDistribution,
                                        setProdusenDesc
                                      )
                                      fieldClearer(8)
                                    }}
                                    options={salesArea}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-incoterm1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm1'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullIncoterm[
                                        fullIncoterm.findIndex(
                                          (item: any) => item.label === incoterm1Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                    }}
                                    options={fullIncoterm}
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('destination-province')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='provinsi'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullProvince[
                                        fullProvince.findIndex(
                                          (item: any) => item.label === provinceDesc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      setFullCity([])
                                      cityData(e?.value)
                                    }}
                                    options={fullProvince}
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-jenis')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='jenis'
                                    onChange={(e: any) => productTypeChange(e.target.value)}
                                  >
                                    {/* <option selected hidden disabled>{t(test?.product_type)}</option> */}
                                    <option hidden value='~#~'>
                                      {t('Pilih-productType')}
                                    </option>
                                    {fullProductType.map((item: any) => {
                                      return (
                                        <>
                                          {item.id != 12 && (
                                            <>
                                              {item.material_group_desc == test?.product_type ? (
                                                <option
                                                  selected
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              ) : (
                                                <option
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('destination-province')}
                                    <span className='text-danger'>*</span>{' '}
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    id='dest-provinsi'
                                    defaultValue={fullProvinceDest.filter((item: any) => item.label == destinationProvinceDesc)}
                                    onChange={(e: any) => cityDestinationData(e?.value)}
                                    options={fullProvinceDest}
                                  />
                                </Col>
                              </Row>
                              
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('Kuantum Pengajuan')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='kuantum'
                                      // key={pname}
                                      placeholder={t('Kuantum Pengajuan')}
                                      defaultValue={quantum}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value) => {
                                        setQuantum(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={3}
                                    />
                                    <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-payment1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='payment1'
                                    onChange={(e) =>
                                      separateValue(setPay1, e.target.value, setPay1Desc)
                                    }
                                  >
                                    <option hidden value=';'>
                                      {t('Pilih-payment')}
                                    </option>
                                    {fullPayment.map((item: any) => {
                                      return (
                                        <>
                                          {item.payment_desc_id == test?.payment_type_1 ? (
                                            <option
                                              selected
                                              value={item.code + ';' + item.payment_desc_id}
                                            >
                                              {item.payment_desc_id}
                                            </option>
                                          ) : (
                                            <option value={item.code + ';' + item.payment_desc_id}>
                                              {item.payment_desc_id}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.payment_note}
                                    placeholder={t('keterangan')}
                                    id='keterangan'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e) => setketerangan(e.target.value)}
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('commodity')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    value={commodity}
                                    placeholder={t('commodity')}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setCommodity(e.target.value)}
                                  />
                                </Col>
                            </Row>
                            </Col>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {localStorage.getItem('cust-group') != 'AR06' ? (
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='sektor'
                                      disabled
                                      onChange={(e) => {
                                        setSektor(e.target.value)
                                        getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                        fieldClearer(7)
                                      }}
                                    >
                                      <option hidden value={0 + ';;'}>
                                        {t('Pilih-sector')}
                                        <span className='text-danger'>*</span>
                                      </option>
                                      {fullSector.map((item: any) => {
                                        return (
                                          <>
                                            {item.name == test?.sector_id ? (
                                              <option
                                                selected
                                                value={item.id + ';' + '' + ';' + item.name}
                                              >
                                                {t(item.name)}
                                              </option>
                                            ) : (
                                              <option value={item.id + ';' + '' + ';' + item.name}>
                                                {t(item.name)}
                                              </option>
                                            )}
                                          </>
                                        )
                                      })}
                                    </Form.Select>
                                  ) : (
                                    <Form.Select
                                      aria-label='Default select example'
                                      id='sektor2'
                                      disabled
                                    >
                                      <option selected>Export</option>
                                    </Form.Select>
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('pickup-province')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='provinsi'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullProvince[
                                        fullProvince.findIndex(
                                          (item: any) => item.label === provinceDesc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      setFullCity([])
                                      cityData(e?.value)
                                    }}
                                    options={fullProvince}
                                  />
                                </Col>
                              </Row>
                              <Row
                                className='mb-4'
                                hidden={roleUser == 'null' ? true : false}
                              >
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm2'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullIncoterm2[
                                        fullIncoterm2.findIndex(
                                          (item: any) => item.label === incoterm2Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                                    }}
                                    options={fullIncoterm2}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('pickup-plant')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='gudang'
                                    key={city}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullPlant[
                                        fullPlant.findIndex(
                                          (item: any) =>
                                            item.label === warehouse + '-' + warehouseDesc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => plantChange(e?.value)}
                                    options={fullPlant}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3'>
                                    {t('sub-order-produk')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produk'
                                    key={ptype}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullProductName[
                                        fullProductName.findIndex(
                                          (item: any) => item.truevalue == parseInt(pnumber)
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      // setQuantum(0)
                                      // setSubprice(0)
                                      productNameChange(e?.value)
                                      // fieldClearer(1)
                                    }}
                                    options={fullProductName}
                                  />
                                </Col>
                              </Row>

                              {/* <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('destination-province')}
                                    <span className='text-danger'>*</span>{' '}
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    id='dest-provinsi'
                                    defaultValue={fullProvinceDest.filter((item: any) => item.label == destinationProvinceDesc)}
                                    onChange={(e: any) => cityDestinationData(e?.value)}
                                    options={fullProvinceDest}
                                  />
                                </Col>
                              </Row> */}
                              
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('Kuantum Pengajuan')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='kuantum'
                                      // key={pname}
                                      placeholder={t('Kuantum Pengajuan')}
                                      defaultValue={quantum}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setQuantum(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={2}
                                    />
                                    <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-payment1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='payment1'
                                    onChange={(e: any) =>
                                      separateValue(setPay1, e.target.value, setPay1Desc)
                                    }
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-payment')}
                                    </option>
                                    {fullPayment.map((item: any) => {
                                      return (
                                        <>
                                          {item.payment_desc_id == test?.payment_type_1 ? (
                                            <option
                                              selected
                                              value={item.code + '~#~' + item.payment_desc_id}
                                            >
                                              {item.payment_desc_id}
                                            </option>
                                          ) : (
                                            <option value={item.code + '~#~' + item.payment_desc_id}>
                                              {item.payment_desc_id}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    defaultValue={test?.payment_note}
                                    placeholder={t('keterangan')}
                                    id='keterangan'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setketerangan(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {localStorage.getItem('cust-group') != 'AR06' ? (
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='sektor'
                                      disabled
                                      onChange={(e: any) => {
                                        setSektor(e.target.value)
                                        getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                        fieldClearer(7)
                                      }}
                                    >
                                      <option hidden value={0 + ';;'}>
                                        {t('Pilih-sector')}
                                        <span className='text-danger'>*</span>
                                      </option>
                                      {fullSector.map((item: any) => {
                                        return (
                                          <>
                                            {item.name == test?.sector_id ? (
                                              <option
                                                selected
                                                value={item.id + '~#~' + '' + '~#~' + item.name}
                                              >
                                                {t(item.name)}
                                              </option>
                                            ) : (
                                              <option value={item.id + '~#~' + '' + '~#~' + item.name}>
                                                {t(item.name)}
                                              </option>
                                            )}
                                          </>
                                        )
                                      })}
                                    </Form.Select>
                                  ) : (
                                    <Form.Select
                                      aria-label='Default select example'
                                      id='sektor2'
                                      disabled
                                    >
                                      <option selected>Export</option>
                                    </Form.Select>
                                  )}
                                </Col>
                              </Row>

                              <Row
                                className='mb-4'
                                hidden={true}
                              >
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm2'
                                    key={idSektor + produsen}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullIncoterm2[
                                        fullIncoterm2.findIndex(
                                          (item: any) => item.label === incoterm2Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                                    }}
                                    options={fullIncoterm2}
                                  />
                                </Col>
                              </Row>
                              
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('destination-city')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='kota'
                                    placeholder={t('pilih')}
                                    key={province}
                                    defaultValue={
                                      fullCity[
                                        fullCity.findIndex((item: any) => item.label === cityDesc)
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setCity, e?.value, setCityDesc)
                                      // fieldClearer(4)
                                    }}
                                    options={fullCity}
                                  />
                                </Col>
                              </Row>
                              
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>
                                    {t('pickup-plant')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='gudang'
                                    key={city}
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      fullPlant[
                                        fullPlant.findIndex(
                                          (item: any) =>
                                            item.label === warehouse + '-' + warehouseDesc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => plantChange(e?.value)}
                                    options={fullPlant}
                                  />
                                </Col>
                              </Row>
                              
                              {/* <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('destination-city')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    key={destinationProvince}
                                    placeholder={t('pilih')}
                                    id='kota'
                                    value={fullDestinationCity.filter((item: any) => item.label === destinationCityDesc)}
                                    onChange={(e: any) => {
                                      separateValue2(setDestinationCity, e?.value, setDestinationCityDesc)
                                      // fieldClearer(4)
                                    }}
                                    options={fullDestinationCity}
                                  />
                                </Col>
                              </Row> */}
                              {/* <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-spek')} <span className='text-danger'>*</span></p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder={t('sub-order-spek')}
                                    as='textarea'
                                    defaultValue={test?.product_spec}
                                    id='spek'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setPspec(e.target.value)}
                                  />
                                </Col>
                              </Row> */}
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('Price')}/Ton<span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder={t('Price')}
                                    size='sm'
                                    key={pnumber}
                                    type='text'
                                    value={
                                      'Rp' + i18next.language === 'en'
                                        ? parseInt(subprice).toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : parseInt(subprice).toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })
                                    }
                                    id='hargap'
                                    disabled
                                  />
                                </Col>
                              </Row>
                              <Row
                                className='mb-4'
                                hidden={!isAdmin ? true : false}
                              >
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='payment2'
                                    onChange={(e: any) =>
                                      separateValue(setPay2, e.target.value, setPay2Desc)
                                    }
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-payment')}
                                    </option>
                                    {fullPayment.map((item: any) => {
                                      return (
                                        <>
                                          {item.payment_desc_id == test?.payment_type_2 ? (
                                            <option
                                              selected
                                              value={item.code + '~#~' + item.payment_desc_id}
                                            >
                                              {item.payment_desc_id}
                                            </option>
                                          ) : (
                                            <option value={item.code + '~#~' + item.payment_desc_id}>
                                              {item.payment_desc_id}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('so-jenisAngkut')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    aria-label='Default select example'
                                    size='sm'
                                    id='ttrans'
                                    placeholder={t('so-jenisAngkut')}
                                    onChange={(e: any) => separateValue(setTransType, e.target.value, setTransType2)}
                                  >
                                    <option selected value='~#~'>
                                      {t('pilih')} {t('so-jenisAngkut')}
                                    </option>
                                    {fullTransport.map((item: any) => {
                                      return (
                                        <>
                                          <option selected={test?.moda_angkut_type == item.name_id} value={item.name_id + '~#~' + item.name_en}>
                                            {i18next.language == 'en' ? item.name_en : item.name_id}
                                          </option>
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('so-namaAngkut')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    aria-label='Default select example'
                                    size='sm'
                                    id='ttrans'
                                    placeholder={t('so-jenisAngkut')}
                                    onChange={(e: any) => {
                                      setTransOptionType(e?.target?.value)
                                      // if (e?.target?.value != 'lainnya') setTrans(e.target.value)
                                    }}
                                  >
                                    <option value='~#~'>
                                      {t('pilih')} {t('so-jenisAngkut')}
                                    </option>
                                    {fullTransportType.map((item: any) => {
                                      return (
                                        <>
                                          <option selected={item.value == transOptionType} value={item.value}>
                                            {item.label}
                                          </option>
                                        </>
                                      )
                                    })}
                                  </Form.Select>

                                  { transOptionType == 'lainnya' && 
                                  <Form.Control
                                    aria-label='Default select example'
                                    size='sm'
                                    className='mt-2'
                                    id='angkutan'
                                    placeholder={t('so-namaAngkut')}
                                    defaultValue={test?.moda_angkut_name}
                                    onChange={(e: any) => setTransportasi(e.target.value)}
                                  />
                                  }
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    defaultValue={test?.notes}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNote(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {nonPenjualanFlag == 'form1' ? (
                        <>
                          <Row>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('kontrak-produsen')}
                                    <span className='text-danger'>*</span>{' '}
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produsen'
                                    placeholder={t('pilih')}
                                    defaultValue={
                                      salesArea[
                                        salesArea.findIndex(
                                          (item: any) => item.label === produsenDesc
                                        )
                                      ]
                                    }
                                    isDisabled
                                    onChange={(e: any) => {
                                      separateValue3(
                                        setProdusen,
                                        e?.value,
                                        setDistribution,
                                        setProdusenDesc
                                      )
                                      fieldClearer(8)
                                    }}
                                    options={salesArea}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    Incoterm
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='incoterm1'
                                    placeholder={t('pilih')}
                                    key={idSektor + produsen}
                                    defaultValue={
                                      fullIncoterm[
                                        fullIncoterm.findIndex(
                                          (item: any) => item.label === incoterm1Desc
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                    }}
                                    options={fullIncoterm}
                                  />
                                </Col>
                              </Row>
                              {idSektor != 3 ? (
                                <>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-provinsi')}
                                        <span className='text-danger'>*</span>{' '}
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='provinsi'
                                        placeholder={t('pilih')}
                                        key={idSektor + produsen}
                                        defaultValue={
                                          fullProvince[
                                            fullProvince.findIndex(
                                              (item: any) => item.label === provinceDesc
                                            )
                                          ]
                                        }
                                        onChange={(e: any) => {
                                          setFullCity([])
                                          cityData(e?.value)
                                        }}
                                        options={fullProvince}
                                      />
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                ''
                              )}
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-jenis')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='jenis'
                                    onChange={(e: any) => productTypeChange(e.target.value)}
                                  >
                                    <option hidden value='~#~'>
                                      {t('Pilih-productType')}
                                    </option>
                                    {fullProductType.map((item: any) => {
                                      return (
                                        <>
                                          {item.id != 12 && (
                                            <>
                                              {item.material_group_desc == test?.product_type ? (
                                                <option
                                                  selected
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              ) : (
                                                <option
                                                  value={
                                                    item.material_group_desc +
                                                    '~#~' +
                                                    item.material_group
                                                  }
                                                >
                                                  {t(item.material_group_desc)}
                                                </option>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('Kuantum Pengajuan')}
                                    <span className='text-danger'>*</span>{' '}
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='kuantum'
                                      // key={pname}
                                      placeholder={t('Kuantum Pengajuan')}
                                      defaultValue={quantum}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setQuantum(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={2}
                                    />
                                    <InputGroup.Text id='basic-addon2'>
                                      {idSektor === 3 ? 'MT' : 'Ton'}
                                    </InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>
                                    {t('End Customer')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  {isNoEnduser || isRetail(idSektor) || idSektor == 3 ? (
                                    <Form.Control
                                      size='sm'
                                      as='textarea'
                                      style={{height: '40px'}}
                                      id='enduser'
                                      placeholder={t('End Customer')}
                                      defaultValue={test?.no_enduser ? test?.end_user : ''}
                                      onChange={(e: any) => {
                                        setEnduser(e.target.value)
                                        setEnduserDesc(e.target.value)
                                      }}
                                    />
                                  ) : (
                                    <MultiSelect
                                      options={fullEndUser?.map((item: any) => {
                                        return {label: item.name, value: item.name}
                                      })}
                                      value={arrayEnduser}
                                      onChange={(e: any) => setEnduserArray(e)}
                                      labelledBy='Select'
                                    />
                                  )}
                                </Col>
                              </Row>

                              {idSektor == 1 && (
                                <Row className='mb-4'>
                                  <Col sm={4}></Col>
                                  <Col sm={8} className='d-flex align-items-center'>
                                    <Form.Check
                                      onClick={() => {
                                        setIsNoEnduser(!isNoEnduser)
                                      }}
                                      defaultChecked={isNoEnduser}
                                      name='noenduser'
                                      disabled={disableCKBOX}
                                      id='noenduser'
                                      className='mt-5 mb-2'
                                      type='checkbox'
                                    />
                                    {i18next.language == 'en' ? (
                                      <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                    ) : (
                                      <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                    )}
                                  </Col>
                                </Row>
                              )}
                            </Col>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    id='sektor'
                                    disabled
                                    onChange={(e: any) => {
                                      setSektor(e.target.value)
                                      getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                      fieldClearer(7)
                                    }}
                                  >
                                    <option hidden value={0 + ';;'}>
                                      {t('Pilih-sector')}
                                      <span className='text-danger'>*</span>
                                    </option>
                                    {fullSector.map((item: any) => {
                                      return (
                                        <>
                                          {item.name == test?.sector_id ? (
                                            <option
                                              selected
                                              value={item.id + '~#~' + '' + '~#~' + item.name}
                                            >
                                              {t(item.name)}
                                            </option>
                                          ) : (
                                            <option value={item.id + '~#~' + '' + '~#~' + item.name}>
                                              {t(item.name)}
                                            </option>
                                          )}
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    defaultValue={test?.notes}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNote(e.target.value)}
                                  />
                                </Col>
                              </Row>

                              {idSektor != 3 ? (
                                <>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-kota')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='kota'
                                        placeholder={t('pilih')}
                                        key={province}
                                        defaultValue={
                                          fullCity[
                                            fullCity.findIndex(
                                              (item: any) => item.label === cityDesc
                                            )
                                          ]
                                        }
                                        onChange={(e: any) => {
                                          separateValue2(setCity, e?.value, setCityDesc)
                                          // fieldClearer(4)
                                        }}
                                        options={fullCity}
                                      />
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                ''
                              )}

                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('sub-order-produk')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Select
                                    id='produk'
                                    placeholder={t('pilih')}
                                    key={ptype}
                                    defaultValue={
                                      fullProductName[
                                        fullProductName.findIndex(
                                          (item: any) => item.truevalue == parseInt(pnumber)
                                        )
                                      ]
                                    }
                                    onChange={(e: any) => {
                                      // setQuantum(0)
                                      // setSubprice(0)
                                      productNameChange(e?.value)
                                      // fieldClearer(1)
                                    }}
                                    options={fullProductName}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('Harga Pengajuan')}/{idSektor === 3 ? 'MT' : 'Ton'}
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <InputGroup.Text id='basic-addon2'>
                                      {idSektor != 3 ? (
                                        <span className='px-1'>Rp</span>
                                      ) : (
                                        <span className='px-2'>USD</span>
                                      )}
                                    </InputGroup.Text>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='hargap'
                                      // key={pname}
                                      defaultValue={subprice}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setSubprice(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={2}
                                      placeholder={t('Harga Pengajuan')}
                                    />
                                  </InputGroup>
                                </Col>
                              </Row>
                              {idSektor != 3 ? (
                                <>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='mt-3'>{t('termasuk-ppn')}</p>
                                    </Col>
                                    <Col sm={8} className='d-flex justify-content-start'>
                                      <Form.Check
                                        reverse
                                        name='ppn'
                                        className='mt-3 mb-2'
                                        type='checkbox'
                                        id='ckbox-ppn'
                                        defaultChecked={test.include_ppn}
                                      />
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row className='mb-3'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>
                                {t('kontrak-produsen')}
                                <span className='text-danger'>*</span>{' '}
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Select
                                id='produsen'
                                placeholder={t('pilih')}
                                defaultValue={
                                  salesArea[
                                    salesArea.findIndex((item: any) => item.label === produsenDesc)
                                  ]
                                }
                                isDisabled
                                onChange={(e: any) => {
                                  separateValue3(
                                    setProdusen,
                                    e?.value,
                                    setDistribution,
                                    setProdusenDesc
                                  )
                                  fieldClearer(8)
                                }}
                                options={salesArea}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-3'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>
                                {t('sub-order-sektor')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Select
                                size='sm'
                                aria-label='Default select example'
                                id='sektor'
                                disabled
                                onChange={(e: any) => {
                                  setSektor(e.target.value)
                                  getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                                  fieldClearer(7)
                                }}
                              >
                                <option hidden value={0 + ';;'}>
                                  {t('Pilih-sector')}
                                  <span className='text-danger'>*</span>
                                </option>
                                {fullSector.map((item: any) => {
                                  return (
                                    <>
                                      {item.name == test?.sector_id ? (
                                        <option
                                          selected
                                          value={item.id + '~#~' + '' + '~#~' + item.name}
                                        >
                                          {t(item.name)}
                                        </option>
                                      ) : (
                                        <option value={item.id + '~#~' + '' + '~#~' + item.name}>
                                          {t(item.name)}
                                        </option>
                                      )}
                                    </>
                                  )
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>
                                {t('sub-order-jenis')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Select
                                size='sm'
                                aria-label='Default select example'
                                id='jenis'
                                onChange={(e: any) => productTypeChange(e.target.value)}
                              >
                                <option hidden value='~#~'>
                                  {t('Pilih-productType')}
                                </option>
                                {fullProductType.map((item: any) => {
                                  return (
                                    <>
                                      {item.id != 12 && (
                                        <>
                                          {item.material_group_desc == test?.product_type ? (
                                            <option
                                              selected
                                              value={
                                                item.material_group_desc + '~#~' + item.material_group
                                              }
                                            >
                                              {t(item.material_group_desc)}
                                            </option>
                                          ) : (
                                            <option
                                              value={
                                                item.material_group_desc + '~#~' + item.material_group
                                              }
                                            >
                                              {t(item.material_group_desc)}
                                            </option>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>
                                {t('sub-order-produk')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Select
                                id='produk'
                                placeholder={t('pilih')}
                                key={ptype}
                                defaultValue={
                                  fullProductName[
                                    fullProductName.findIndex(
                                      (item: any) => item.truevalue == parseInt(pnumber)
                                    )
                                  ]
                                }
                                onChange={(e: any) => {
                                  // setQuantum(0)
                                  // setSubprice(0)
                                  productNameChange(e?.value)
                                  // fieldClearer(1)
                                }}
                                options={fullProductName}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('sub-order-catatan')}
                                defaultValue={test?.notes}
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setNote(e.target.value)}
                              />
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  )}
                  <div className='d-flex justify-content-end mt-5'>
                    <Button disabled={loadingAddProduct} variant='primary' onClick={() => editOrder(tempID)}>
                      <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                      {t('order-kirim')}
                    </Button>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            show={showJadwal}
            onHide={() => setShowJadwal(false)}
            backdrop='static'
            keyboard={false}
            centered
            scrollable
            size='xl'
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
                {pname} | {fixedQuantum} Ton
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div key={tempkey}>
                <span style={{fontSize: '15px'}} className='fw-bold d-block'>
                  {t('Jadwal')}
                </span>
                <div className='table-responsive bdr mt-1'>
                  <table className='table-border w-100'>
                    <thead>
                      <tr className='d-flex'>
                        {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                        <th style={{width: '165.5px'}} className='text-center'>
                          {t('order-pengambilan')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-tanggal')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-minggu')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-bulan')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-tahun')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-tonase')}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <div>
                        <tr className='d-flex'>
                          <td style={{width: '165.5px'}} className='text-center'>
                            <p className='mt-3'>{taking + 1}</p>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              id='jadwaltanggal'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                            >
                              <option selected value={0} disabled hidden>
                                {t('Pilih-Tanggal')}
                              </option>
                              {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            {/* <Form.Select
                              aria-label='Default select example'
                              id='jadwalminggu'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem'}}
                              onChange={(e: any) => setTempMinggu(parseInt(e.target.value))}
                            >
                              <option selected disabled>
                                {t('Pilih-minggu')}
                              </option>
                              <option value='1'>{t('Week')}1</option>
                              <option value='2'>{t('Week')}2</option>
                              <option value='3'>{t('Week')}3</option>
                              <option value='4'>{t('Week')}4</option>
                            </Form.Select> */}
                            <Form.Control
                              aria-label='Default select example'
                              id='jadwalminggu'
                              placeholder={t('order-minggu')}
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              value={tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)}
                            />
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center  d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              id='jadwalbulan'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                            >
                              <option selected disabled>
                                {t('Pilih-Month')}
                              </option>
                              <option value='1'>{t('Januari')}</option>
                              <option value='2'>{t('Februari')}</option>
                              <option value='3'>{t('Maret')}</option>
                              <option value='4'>{t('April')}</option>
                              <option value='5'>{t('Mei')}</option>
                              <option value='6'>{t('Juni')}</option>
                              <option value='7'>{t('Juli')}</option>
                              <option value='8'>{t('Agustus')}</option>
                              <option value='9'>{t('September')}</option>
                              <option value='10'>{t('Oktober')}</option>
                              <option value='11'>{t('November')}</option>
                              <option value='12'>{t('Desember')}</option>
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center  d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              id='jadwaltahun'
                              onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                            >
                              <option selected disabled>
                                {t('Pilih-Year')}
                              </option>
                              {listYear.map((data: string, index: number) => {
                                return (
                                  <option key={data ?? index} value={data}>
                                    {data}
                                  </option>
                                )
                              })}
                              {/* <option value='2023'>2023</option>
                              <option value='2024'>2024</option>
                              <option value='2025'>2025</option>
                              <option value='2026'>2026</option>
                              <option value='2027'>2027</option>
                              <option value='2028'>2028</option>
                              <option value='2029'>2029</option>
                              <option value='2030'>2030</option>
                              <option value='2031'>2031</option> */}
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <CurrencyInput
                              id='jadwalton'
                              className='form-control form-control-sm'
                              placeholder={t('order-tonase')}
                              style={{width: '90%'}}
                              key={tempTahun}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setTempTon(parseFloat(value?.replace(/,/g, '.')))
                              }}
                              decimalsLimit={2}
                            />
                          </td>
                        </tr>
                      </div>
                    </tbody>
                    <div className='d-flex justify-content-end mt-5'>
                      <Button
                        variant='primary'
                        onClick={() => {
                          sendJadwal()
                        }}
                      >
                        {t('order-kirim')}
                      </Button>
                    </div>
                  </table>
                </div>
                <div
                  className='table-responsive bdr mt-8'
                  hidden={allJadwal?.length < 1 || allJadwal?.length == undefined ? true : false}
                >
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='border-bottom'>
                      <tr className='fw-bold d-flex'>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-pengambilan')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-tanggal')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-minggu')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-bulan')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-tahun')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-tonase')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-aksi')}
                        </th>
                      </tr>
                    </thead>
                    {allJadwal?.map((data, _index) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className='d-flex'>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{_index + 1}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{data.date}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>
                              {t('Week') + Math.ceil(data.date / 7)}
                              {/* {data.week} */}
                            </label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{data.year}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            {editedIndex == _index ? (
                              <CurrencyInput
                                id='ton'
                                placeholder={t('order-tonase')}
                                className='form-control form-control-sm'
                                defaultValue={data.tonnage}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setTempTon(parseFloat(value?.replace(/,/g, '.')))
                                }}
                                decimalsLimit={2}
                              />
                            ) : (
                              <label className='mt-3'>
                                {(i18next.language === 'en'
                                  ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                                  : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                                  ' ' +
                                  'Ton'}
                              </label>
                            )}
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            {editedIndex == _index ? (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Approve')}
                                onClick={() => rubahSchedule(_index, tempTon, data.tonnage)}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/check-square.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('ubah')}
                                onClick={() => {
                                  setEditedIndex(_index)
                                  setTempTon(data.tonnage)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/pencil-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}

                            <button
                              onClick={() => hapusSchedule(_index)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showDetail2}
            onHide={() => setShowDetail2(false)}
            centered
            scrollable
            size='xl'
            backdrop='static'
          >
            <Modal.Header closeButton>
              <Modal.Title>Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {tempDetail?.sector_id == 1 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>Sales Org</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.incoterm1?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          type='text'
                          value={tempDetail.province?.region_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_type_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.so_qty_realized)
                                ).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) +
                                ' ' +
                                'Ton'
                              : (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.so_qty_realized)
                                ).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) +
                                ' ' +
                                'Ton'
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          // placeholder={t('Shipping Tolerance')}
                          size='sm'
                          type='text'
                          id='shipping'
                          value={
                            tempDetail?.shipping_tolerance == 0
                              ? ''
                              : tempDetail?.shipping_tolerance + '%'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_type_1_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_note}
                          as='textarea'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('segment')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail?.segment_name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('End Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.end_user}
                          as='textarea'
                          style={{height: '40px'}}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail.sector?.name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={8}>
                        {tempDetail?.incoterm2 == null ? (
                          <Form.Control
                            value={
                              tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                                ? ''
                                : tempDetail?.incoterm2_id
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={tempDetail?.incoterm2?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          type='text'
                          value={tempDetail.city?.city_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-2'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={
                            'Rp' + i18next.language === 'en'
                              ? parseInt(tempDetail?.fixed_price).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseInt(tempDetail?.fixed_price).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                      </Col>
                      <Col sm={8} className='d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='ppn'
                          className='mt-5 mb-2'
                          type='checkbox'
                          id='ckbox-ppn'
                          checked={tempDetail?.include_ppn}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_type_2_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_spec}
                          type='text'
                          as='textarea'
                          style={{height: '40px'}}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.notes}
                          as='textarea'
                          style={{height: '40px'}}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail.amandement_notes)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail.extension_date)}
                          type={ tempDetail.extension_date ? 'date' : 'text' }
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {isRetail(tempDetail?.sector_id) && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>Sales Org</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.incoterm1?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          type='text'
                          value={tempDetail.province?.region_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.plant + " - " + tempDetail.plant_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.so_qty_realized)
                                ).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) +
                                ' ' +
                                'Ton'
                              : (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.so_qty_realized)
                                ).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) +
                                ' ' +
                                'Ton'
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_type_1_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_note}
                          as='textarea'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail.sector?.name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('End Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.end_user}
                          as='textarea'
                          style={{height: '40px'}}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={8}>
                        {tempDetail?.incoterm2 == null ? (
                          <Form.Control
                            value={
                              tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                                ? ''
                                : tempDetail?.incoterm2_id
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={tempDetail?.incoterm2?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          type='text'
                          value={tempDetail.city?.city_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_type_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_spec}
                          type='text'
                          as='textarea'
                          style={{height: '40px'}}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={
                            'Rp' + i18next.language === 'en'
                              ? parseInt(tempDetail?.fixed_price).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseInt(tempDetail?.fixed_price).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.notes}
                          as='textarea'
                          style={{height: '40px'}}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {tempDetail?.sector_id == 3 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>Sales Org</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.incoterm1?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          type='text'
                          value={tempDetail.province?.region_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_type_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.so_qty_realized)
                                ).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) +
                                ' ' +
                                'MT'
                              : (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.so_qty_realized)
                                ).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) +
                                ' ' +
                                'MT'
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          // placeholder={t('Shipping Tolerance')}
                          size='sm'
                          type='text'
                          id='shipping'
                          value={
                            tempDetail?.shipping_tolerance == 0
                              ? ''
                              : tempDetail?.shipping_tolerance + '%'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_type_1_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_note}
                          as='textarea'
                          disabled
                          style={{height: '40px'}}
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('End Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.end_user}
                          as='textarea'
                          disabled
                          style={{height: '40px'}}
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail.sector?.name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={8}>
                        {tempDetail?.incoterm2 == null ? (
                          <Form.Control
                            value={
                              tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                                ? ''
                                : tempDetail?.incoterm2_id
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={tempDetail?.incoterm2?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          type='text'
                          value={tempDetail.city?.city_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={'USD' + PriceFormater(tempDetail?.fixed_price)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                      </Col>
                      <Col sm={8} className='d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='ppn'
                          className='mt-5 mb-2'
                          type='checkbox'
                          id='ckbox-ppn'
                          checked={tempDetail?.include_ppn}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.payment_type_2_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail.product_spec}
                          type='text'
                          as='textarea'
                          style={{height: '40px'}}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={tempDetail?.notes}
                          as='textarea'
                          style={{height: '40px'}}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail.amandement_notes)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={t(tempDetail.extension_date)}
                          type={ tempDetail.extension_date ? 'date' : 'text' }
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            size='lg'
            show={showUpload}
            onHide={() => {
              setIsFileBox(false)
              setShowUpload(false)
            }}
            backdrop='static'
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {isFileBox
                  ? (sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : '') +
                    pname +
                    ' | ' +
                    fixedQuantum +
                    ' Ton'
                  : t('File Box')}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {allFile.length < 1 || allFile.length == undefined ? (
                <></>
              ) : (
                <>
                  <div className='table-responsive mt-4 bdr'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead className='fw-bold border-bottom'>
                        <tr className=''>
                          <th className='text-center'>{t('order-noo')}</th>
                          <th className='text-center'>{t('order-keterangan')}</th>
                          <th className='text-center'>{t('order-tglUpload')}</th>
                          {/* <th className='text-center'>{t('User Code')}</th> */}
                          <th className='text-center'>{t('order-user')}</th>
                          <th className='text-center'>{t('Akses Role')}</th>
                          <th className='text-center'>{t('order-aksi')}</th>
                        </tr>
                      </thead>
                      {allFile.map((data: any, _index: number) => (
                        <tbody key={data?.id ?? _index}>
                          <tr className=''>
                            <td className='text-center'>
                              <label>{_index + 1}</label>
                            </td>
                            <td className='text-center'>
                              <label>{data.description}</label>
                            </td>
                            <td className='text-center'>
                              <label>{dateformat(data.updated_at)}</label>
                            </td>
                            {/* <td className='text-center'>
                              <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                            </td> */}
                            <td className='text-center'>
                              {data.user?.customer_code == null ? (
                                <label>{data.user?.name}</label>
                              ) : (
                                <label>{data.user?.customer?.name}</label>
                              )}
                            </td>
                            <td className='text-center'>
                              {data.private ? (
                                data.roles.length > 0 ? (
                                  <PopoverText
                                    content={handleShowRoleName(data.roles)}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                ) : (
                                  'Private'
                                )
                              ) : (
                                'Public'
                              )}
                            </td>
                            <td className='text-center'>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('unduh')}
                                onClick={() =>
                                  window.open(
                                    data.file_path + `&token=${localStorage.getItem('token')}`
                                  )
                                }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrow-down-square-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            size='lg'
            show={show1}
            onHide={() => {
              setShow1(false)
              setIsPrivate(false)
            }}
            backdrop='static'
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
                {pname} | {fixedQuantum} Ton
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col sm={6}>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-fileUnggah')}</h6>
                      </td>
                      <td className='w-75'>
                        <InputFile
                            setFileName={setNamaFile}
                            setFiles={setFiles}
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-keterangan')}</h6>
                      </td>
                      <td className='w-75'>
                        <Form.Control
                          type='text'
                          id='uploadketerangan'
                          placeholder={t('order-keterangan')}
                          onChange={(e: any) => setDescription(e.target.value)}
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3' hidden={roleUser === 'null' ? true : false}>
                    <tr>
                      <td>
                        <h6 className='me-11'>{t('Private')}</h6>
                      </td>
                      <td className='w-75 d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='isPrivate'
                          type='checkbox'
                          className='mt-5 mb-2'
                          onClick={() => {
                            setIsPrivate(!isPrivate)
                            setTempRole([])
                          }}
                          id='isPrivate2'
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3' hidden={isPrivate ? false : true}>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('Akses Role')}</h6>
                      </td>
                      <td className='w-75' style={{maxWidth: '274px'}}>
                        <MultiSelect
                          key={files}
                          options={fullRole?.map((item: any) => {
                            return {label: item.label, value: item.value}
                          })}
                          value={tempRole}
                          onChange={(e: any) => setTempRole(e)}
                          labelledBy='Select'
                        />
                      </td>
                    </tr>
                  </table>
                  <div className='d-flex justify-content-end'>
                    {uploadType == 'header' ? (
                      <Button variant='primary' className='w-100' onClick={() => handleUpload()}>
                        {t('order-kirim')}
                      </Button>
                    ) : (
                      <Button variant='primary' className='w-100' onClick={() => handleUpload2()}>
                        {t('order-kirim')}
                      </Button>
                    )}
                  </div>
                </Col>
                <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        {/* {isRetail(idSektor) ? (
                                      <>
                                        <th className='text-center'>{t('order-namaFile')}</th>
                                        <th className='text-center'>{t('order-jenisFile')}</th>
                                      </>
                                    ) : ''} */}
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {uploadType == 'header' ? (
                      <>
                        {fileHeader
                          .slice(0)
                          .reverse()
                          .map((data: any, _index: number) => (
                            <tbody key={data?.id ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{dateformat(getCurrentFormattedDate())}</label>
                                </td>
                                {/* <td className='text-center'>
                                  <label>
                                    {localStorage.getItem('cust-code') !== 'null'
                                      ? localStorage.getItem('cust-code')
                                      : localStorage.getItem('user_code')}
                                  </label>
                                </td> */}
                                <td className='text-center'>
                                  <label>{localStorage.getItem('username')}</label>
                                </td>
                                <td className='text-center'>
                                  {data.private ? (
                                    data.roles.length > 0 ? (
                                      <PopoverText
                                        content={handleShowRoleName(data.roles)}
                                        index={_index}
                                        className='desc-slice'
                                      />
                                    ) : (
                                      'Private'
                                    )
                                  ) : (
                                    'Public'
                                  )}
                                </td>
                                <td className='text-center'>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('unduh')}
                                    onClick={() => download_file(data.file_r, data.name)}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDeleteUploadHeader(
                                        fileHeader.length - 1 - _index,
                                        fileHeader,
                                        setFileHeader,
                                        'header',
                                        tempData,
                                        setTempData
                                      )
                                    }
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                      </>
                    ) : (
                      <>
                        {orderItemFiles
                          .slice(0)
                          .reverse()
                          .map((data: any, _index: number) => (
                            <tbody key={data?.id ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{dateformat(getCurrentFormattedDate())}</label>
                                </td>
                                {/* <td className='text-center'>
                                  <label>
                                    {localStorage.getItem('cust-code') !== 'null'
                                      ? localStorage.getItem('cust-code')
                                      : localStorage.getItem('user_code')}
                                  </label>
                                </td> */}
                                <td className='text-center'>
                                  <label>{localStorage.getItem('username')}</label>
                                </td>
                                <td className='text-center'>
                                  {data.private ? (
                                    data.roles.length > 0 ? (
                                      <PopoverText
                                        content={handleShowRoleName(data.roles)}
                                        index={_index}
                                        className='desc-slice'
                                      />
                                    ) : (
                                      'Private'
                                    )
                                  ) : (
                                    'Public'
                                  )}
                                </td>
                                <td className='text-center'>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('unduh')}
                                    onClick={() => download_file(data.file_r, data.name)}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDeleteUploadHeader(
                                        orderItemFiles.length - 1 - _index,
                                        orderItemFiles,
                                        setOrderItemsFiles,
                                        'order-item',
                                        tempData,
                                        setTempData
                                      )
                                    }
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                      </>
                    )}
                  </table>
                </div>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        <div>
          <label>Loading...</label>
        </div>
      )}
    </>
  )
}

export {OrderCreate}
